var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSenstra06(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1393,
    height: 1030,
    viewBox: "0 0 1393 1030",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2490",
    "data-name": "Group 2490",
    transform: "translate(-264 -9938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M0,0H348V344H0Z",
    transform: "translate(264 9938)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M0,0H348V344H0Z",
    transform: "translate(1309 10282)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M0,0H348V342H0Z",
    transform: "translate(264 10626)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M0,0H349V344H0Z",
    transform: "translate(960 9938)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M0,0H348V344H0Z",
    transform: "translate(612 10282)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M0,0H349V342H0Z",
    transform: "translate(960 10626)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M0,0H348V344H0Z",
    transform: "translate(612 9938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M0,0H349V344H0Z",
    transform: "translate(960 10282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M0,0H348V342H0Z",
    transform: "translate(612 10626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M0,0H348V344H0Z",
    transform: "translate(1309 9938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M0,0H348V344H0Z",
    transform: "translate(264 10282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M0,0H348V342H0Z",
    transform: "translate(1309 10626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M351.319,343.822",
    transform: "translate(571.758 9957.34)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_550",
    "data-name": "Group 550",
    transform: "translate(709.037 10040.612)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540",
    transform: "translate(0 112.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M270.655,292.547v8.64H264.7v-24.63h9.65q4.389,0,6.689,2.176a7.706,7.706,0,0,1,2.3,5.871,8.076,8.076,0,0,1-1.027,4.092,7.133,7.133,0,0,1-3.049,2.824,10.738,10.738,0,0,1-4.912,1.027Zm6.619-7.943q0-3.24-3.588-3.24h-3.031v6.41h3.031Q277.274,287.774,277.274,284.6Z",
    transform: "translate(-264.698 -276.557)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M282.815,279.747a7.348,7.348,0,0,1,3.813-1.045v6.375h-1.707a5.885,5.885,0,0,0-3.674,1.01,4.061,4.061,0,0,0-1.307,3.416v8.846h-5.957V278.911h5.957v3.658A8.456,8.456,0,0,1,282.815,279.747Z",
    transform: "translate(-252.419 -273.72)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M299.371,289.729H285.892A4.512,4.512,0,0,0,287,292.883a3.594,3.594,0,0,0,2.578.957,3.53,3.53,0,0,0,2.2-.662,3.091,3.091,0,0,0,1.15-1.707h6.305a8.273,8.273,0,0,1-1.672,3.674,8.931,8.931,0,0,1-3.275,2.543,11.163,11.163,0,0,1-9.494-.276,8.588,8.588,0,0,1-3.465-3.467,10.727,10.727,0,0,1-1.254-5.293,10.847,10.847,0,0,1,1.236-5.316,8.468,8.468,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.368,8.368,0,0,1,3.4,3.328,9.892,9.892,0,0,1,1.2,4.928A8.207,8.207,0,0,1,299.371,289.729Zm-6.879-5.381a3.781,3.781,0,0,0-2.629-.959,3.908,3.908,0,0,0-2.717.975,4.076,4.076,0,0,0-1.222,2.857h7.6A3.587,3.587,0,0,0,292.492,284.348Z",
    transform: "translate(-244.364 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M303.186,280.532a8.03,8.03,0,0,1,2.771,4.877h-5.576a3.093,3.093,0,0,0-1.094-1.865,3.357,3.357,0,0,0-2.144-.678,2.343,2.343,0,0,0-1.533.437,1.514,1.514,0,0,0-.523,1.236,1.45,1.45,0,0,0,.957,1.359,15.085,15.085,0,0,0,3.015.906,29.433,29.433,0,0,1,3.656,1.064,6.038,6.038,0,0,1,2.476,1.758,4.874,4.874,0,0,1,1.045,3.275,5.008,5.008,0,0,1-.908,2.961,5.963,5.963,0,0,1-2.613,2.02,10.189,10.189,0,0,1-4.039.734,10.4,10.4,0,0,1-6.306-1.742,7.338,7.338,0,0,1-2.891-4.984h5.748a2.58,2.58,0,0,0,1.064,1.916,3.991,3.991,0,0,0,2.385.662,2.21,2.21,0,0,0,1.533-.471,1.586,1.586,0,0,0,.523-1.235,1.487,1.487,0,0,0-.957-1.445,17.522,17.522,0,0,0-3.119-.922,24.9,24.9,0,0,1-3.553-.978,5.855,5.855,0,0,1-2.406-1.689,4.709,4.709,0,0,1-1.008-3.189,5.2,5.2,0,0,1,1.983-4.231,8.657,8.657,0,0,1,5.609-1.619A8.917,8.917,0,0,1,303.186,280.532Z",
    transform: "translate(-231.926 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M311.511,280.532a8.03,8.03,0,0,1,2.771,4.877h-5.576a3.093,3.093,0,0,0-1.094-1.865,3.353,3.353,0,0,0-2.144-.678,2.343,2.343,0,0,0-1.533.437,1.514,1.514,0,0,0-.523,1.236,1.45,1.45,0,0,0,.957,1.359,15.136,15.136,0,0,0,3.014.906,29.425,29.425,0,0,1,3.656,1.064,6.023,6.023,0,0,1,2.476,1.758,4.862,4.862,0,0,1,1.045,3.275,5.007,5.007,0,0,1-.908,2.961,5.937,5.937,0,0,1-2.613,2.02,10.188,10.188,0,0,1-4.039.734,10.4,10.4,0,0,1-6.305-1.742,7.355,7.355,0,0,1-2.892-4.984h5.748a2.581,2.581,0,0,0,1.064,1.916,3.991,3.991,0,0,0,2.385.662,2.21,2.21,0,0,0,1.533-.471,1.578,1.578,0,0,0,.523-1.235,1.487,1.487,0,0,0-.957-1.445,17.521,17.521,0,0,0-3.119-.922,24.9,24.9,0,0,1-3.553-.978,5.847,5.847,0,0,1-2.4-1.689,4.71,4.71,0,0,1-1.01-3.189A5.2,5.2,0,0,1,300,280.307a8.66,8.66,0,0,1,5.611-1.619A8.915,8.915,0,0,1,311.511,280.532Z",
    transform: "translate(-220.917 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M325.937,278.792v19.439h-5.992v-3.518a6.47,6.47,0,0,1-2.49,2.717,7.249,7.249,0,0,1-3.851,1.01,6.727,6.727,0,0,1-5.314-2.23,8.954,8.954,0,0,1-1.967-6.131V278.792h5.922v10.556a4.341,4.341,0,0,0,1.029,3.084,3.618,3.618,0,0,0,2.768,1.1,3.674,3.674,0,0,0,2.857-1.147,4.706,4.706,0,0,0,1.045-3.277V278.792Z",
    transform: "translate(-209.649 -273.601)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M325.369,279.747a7.363,7.363,0,0,1,3.816-1.045v6.375h-1.709a5.889,5.889,0,0,0-3.674,1.01A4.06,4.06,0,0,0,322.5,289.5v8.846h-5.957V278.911H322.5v3.658A8.428,8.428,0,0,1,325.369,279.747Z",
    transform: "translate(-196.14 -273.72)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M341.929,289.729H328.447a4.513,4.513,0,0,0,1.115,3.154,3.594,3.594,0,0,0,2.578.957,3.523,3.523,0,0,0,2.195-.662,3.09,3.09,0,0,0,1.15-1.707h6.306a8.244,8.244,0,0,1-1.67,3.674,8.939,8.939,0,0,1-3.277,2.543,11.157,11.157,0,0,1-9.492-.276,8.608,8.608,0,0,1-3.467-3.467,11.914,11.914,0,0,1-.016-10.609,8.468,8.468,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.382,8.382,0,0,1,3.4,3.328,9.916,9.916,0,0,1,1.2,4.928A8.214,8.214,0,0,1,341.929,289.729Zm-6.879-5.381a3.791,3.791,0,0,0-2.631-.959,3.911,3.911,0,0,0-2.717.975,4.084,4.084,0,0,0-1.219,2.857h7.594A3.578,3.578,0,0,0,335.049,284.348Z",
    transform: "translate(-188.087 -273.739)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "outline",
    transform: "translate(30.052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M310.865,278.008a23.229,23.229,0,1,0-23.229-23.229A23.27,23.27,0,0,0,310.865,278.008Z",
    transform: "translate(-264.415 -223.401)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M346.164,253.121a31.32,31.32,0,1,0-36.96,36.96v5.59h12.544v-5.59A31.314,31.314,0,0,0,346.164,253.121Zm-30.687,32.932a26.635,26.635,0,1,1,26.634-26.634A26.633,26.633,0,0,1,315.477,286.053Z",
    transform: "translate(-269.027 -228.041)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M296.96,248.693h3.133v3.133H296.96Z",
    transform: "translate(-252.085 -200.73)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M294.486,258.748a1.572,1.572,0,0,0,1.108-.458l6.264-6.266.009-.014a4.638,4.638,0,0,0,2.016.471,4.67,4.67,0,0,0,4.229-6.714l.014-.009,6.266-6.266a1.566,1.566,0,0,0-2.216-2.213l-6.264,6.266-.009.014a4.62,4.62,0,0,0-2.021-.474,4.7,4.7,0,0,0-4.7,4.7,4.627,4.627,0,0,0,.469,2.016l-.014.009-6.264,6.266a1.565,1.565,0,0,0,1.11,2.673Z",
    transform: "translate(-257.433 -216.408)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541",
    transform: "translate(0 67.629)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1033",
    "data-name": "Rectangle 1033",
    width: 27.88,
    height: 15.483,
    rx: 0.835,
    transform: "translate(0 3.086)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1034",
    "data-name": "Rectangle 1034",
    width: 27.88,
    height: 15.483,
    rx: 0.835,
    transform: "translate(65.019 3.086)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1035",
    "data-name": "Rectangle 1035",
    width: 9.285,
    height: 21.681,
    rx: 0.496,
    transform: "translate(6.198)",
    fill: "#fff",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M326.775,262.368V273.59h-9.311v3.978a1.262,1.262,0,0,1-1.275,1.275H300.223a1.279,1.279,0,0,1-1.277-1.275V273.59h-9.308V262.368h9.308v-3.955a1.274,1.274,0,0,1,1.277-1.25H316.19a1.257,1.257,0,0,1,1.275,1.25v3.955Z",
    transform: "translate(-261.769 -257.158)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1036",
    "data-name": "Rectangle 1036",
    width: 9.284,
    height: 21.681,
    rx: 0.5,
    transform: "translate(77.415)",
    fill: "#fff",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1037",
    "data-name": "Rectangle 1037",
    width: 3.096,
    height: 3.096,
    transform: "translate(18.586 9.29)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1038",
    "data-name": "Rectangle 1038",
    width: 3.096,
    height: 3.096,
    transform: "translate(41.806 9.29)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1039",
    "data-name": "Rectangle 1039",
    width: 3.088,
    height: 3.096,
    transform: "translate(48.006 9.29)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1040",
    "data-name": "Rectangle 1040",
    width: 3.096,
    height: 3.096,
    transform: "translate(71.218 9.29)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549",
    transform: "translate(51.213 5.802)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542",
    transform: "translate(25.28)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    y2: 5.44,
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543",
    transform: "translate(14.431 2.405)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x2: 2.299,
    y2: 4.931,
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x2: 2.299,
    y2: 4.93,
    transform: "translate(19.398 41.6)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544",
    transform: "translate(5.615 9.17)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x2: 4.167,
    y2: 3.497,
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x2: 4.167,
    y2: 3.497,
    transform: "translate(35.162 29.504)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545",
    transform: "translate(0.485 19.026)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x2: 5.255,
    y2: 1.408,
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x2: 5.255,
    y2: 1.408,
    transform: "translate(44.336 11.88)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(0 21.212)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    y1: 0.945,
    x2: 5.357,
    transform: "translate(0 7.97)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    y1: 0.945,
    x2: 5.357,
    transform: "translate(45.203)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547",
    transform: "translate(4.252 10.946)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    y1: 3.12,
    x2: 4.456,
    transform: "translate(0 26.327)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    y1: 3.12,
    x2: 4.456,
    transform: "translate(37.599)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(12.445 3.439)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    y1: 4.711,
    x2: 2.72,
    transform: "translate(0 39.751)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    y1: 4.711,
    x2: 2.72,
    transform: "translate(22.95)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562",
    transform: "translate(320.494 10003.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559",
    transform: "translate(71.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_555",
    "data-name": "Group 555",
    transform: "translate(20.663 29.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_552",
    "data-name": "Group 552"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_551",
    "data-name": "Group 551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M167.524,278.432v-35.6a14.945,14.945,0,1,0-29.89,0v35.6a22.416,22.416,0,1,0,29.89,0Z",
    transform: "translate(-130.16 -227.888)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_554",
    "data-name": "Group 554",
    transform: "translate(9.371 23.571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_553",
    "data-name": "Group 553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M160.288,281.534a13.046,13.046,0,1,1-17.4-12.3v-31.2h8.7v31.2A13.029,13.029,0,0,1,160.288,281.534Z",
    transform: "translate(-134.195 -238.037)",
    fill: "#e1e1e2",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M138.12,233.647H124.141",
    transform: "translate(-117.457 -191.095)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M134.708,237.086h-7.987",
    transform: "translate(-114.045 -186.547)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M138.12,240.526H124.141",
    transform: "translate(-117.457 -181.998)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M138.12,247.4H124.141",
    transform: "translate(-117.457 -172.902)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M134.708,243.965h-7.987",
    transform: "translate(-114.045 -177.45)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_556",
    "data-name": "Group 556",
    transform: "translate(13.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M139.7,240.424a12.549,12.549,0,1,0-12.551-12.551A12.552,12.552,0,0,0,139.7,240.424Z",
    transform: "translate(-127.15 -215.325)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M134.985,221.072a5.63,5.63,0,0,1,.079.948,1.141,1.141,0,0,0,2.283,0,7.974,7.974,0,0,0-.116-1.328,1.14,1.14,0,0,0-2.248.381Z",
    transform: "translate(-116.81 -209.472)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M133.2,219.571a5.628,5.628,0,0,1,.948.079,1.056,1.056,0,0,0,.19.016l.06-.012a1.017,1.017,0,0,0,.176.084,5.717,5.717,0,0,1,2.585,1.431c.023.023.049.044.074.067a.956.956,0,0,1,.077.086c.1.1.193.207.283.316a1.141,1.141,0,0,0,1.756-1.456c-.128-.153-.26-.3-.4-.448a1,1,0,0,0-.1-.093,1.249,1.249,0,0,0-.1-.116,7.987,7.987,0,0,0-3.616-2,1.09,1.09,0,0,0-.314-.014,1.05,1.05,0,0,0-.286-.114,7.7,7.7,0,0,0-1.326-.1,1.14,1.14,0,0,0,0,2.281Z",
    transform: "translate(-120.653 -212.727)",
    fill: "#e1e1e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_557",
    "data-name": "Group 557",
    transform: "translate(67.796 60.002)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M174.995,250a12.549,12.549,0,1,0-8.275,15.7h0A12.565,12.565,0,0,0,174.995,250Z",
    transform: "translate(-150.455 -241.161)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M155.138,248.632a5.94,5.94,0,0,1-.355-.883,1.14,1.14,0,1,0-2.178.676,7.98,7.98,0,0,0,.5,1.233,1.141,1.141,0,0,0,2.053-1l-.016-.033Z",
    transform: "translate(-147.68 -233.51)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M160.336,249.406a5.721,5.721,0,0,1-.929.207,1.031,1.031,0,0,0-.216.074,1.014,1.014,0,0,0-.221-.033,5.7,5.7,0,0,1-2.887-.6c-.03-.016-.063-.03-.1-.044a.755.755,0,0,0-.093-.056c-.125-.07-.249-.144-.367-.223a1.141,1.141,0,0,0-1.273,1.9l.026.016c.167.109.334.211.511.307a1.158,1.158,0,0,0,.132.063.954.954,0,0,0,.132.079,7.966,7.966,0,0,0,4.048.848,1.086,1.086,0,0,0,.283-.074,1.017,1.017,0,0,0,.325.019,8.081,8.081,0,0,0,1.3-.295,1.142,1.142,0,1,0-.676-2.181Z",
    transform: "translate(-146.096 -231.406)",
    fill: "#e1e1e2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_558",
    "data-name": "Group 558",
    transform: "translate(64.285 22.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M173.483,233.776a12.549,12.549,0,1,0-8.273,15.7A12.548,12.548,0,0,0,173.483,233.776Z",
    transform: "translate(-148.943 -224.936)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M154.184,229.621a5.479,5.479,0,0,1,.883-.355,1.142,1.142,0,1,0-.676-2.181,7.8,7.8,0,0,0-1.233.5,1.144,1.144,0,0,0-.581,1.354,1.043,1.043,0,0,0,.072.177,1.142,1.142,0,0,0,1.533.506Z",
    transform: "translate(-144.202 -222.161)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M153.449,234.8a5.583,5.583,0,0,1-.207-.929.988.988,0,0,0-.074-.216,1.009,1.009,0,0,0,.033-.221,5.712,5.712,0,0,1,.6-2.889c.016-.03.028-.063.042-.093s.042-.063.06-.1c.067-.123.142-.246.218-.365a1.141,1.141,0,0,0-1.911-1.247c-.109.17-.214.339-.309.516a.9.9,0,0,0-.058.128.951.951,0,0,0-.079.132,7.988,7.988,0,0,0-.845,4.048,1.114,1.114,0,0,0,.049.274c.007.019.021.035.028.053a1.14,1.14,0,0,0-.019.281,8.006,8.006,0,0,0,.29,1.3,1.141,1.141,0,0,0,2.181-.674Z",
    transform: "translate(-146.344 -220.562)",
    fill: "#e1e1e2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M121.263,258.914a3.945,3.945,0,1,0,3.944-3.944A3.945,3.945,0,0,0,121.263,258.914Z",
    transform: "translate(-121.263 -162.896)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M155.673,239.989a3.422,3.422,0,1,0-2.255,4.283A3.422,3.422,0,0,0,155.673,239.989Z",
    transform: "translate(-84.608 -185.897)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M145.988,228.745a4.009,4.009,0,1,1,4.006-4.009A4.008,4.008,0,0,1,145.988,228.745Z",
    transform: "translate(-93.867 -208.18)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561",
    transform: "translate(0 142.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M109.711,276.557v4.74h-6.689v19.89H97.031V281.3H90.414v-4.74Z",
    transform: "translate(-90.414 -276.557)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M118.666,289.731H105.184a4.528,4.528,0,0,0,1.115,3.154,3.6,3.6,0,0,0,2.578.957,3.545,3.545,0,0,0,2.2-.662,3.1,3.1,0,0,0,1.15-1.707h6.305a8.274,8.274,0,0,1-1.672,3.674,8.9,8.9,0,0,1-3.275,2.541,11.163,11.163,0,0,1-9.494-.276,8.583,8.583,0,0,1-3.465-3.465,10.736,10.736,0,0,1-1.254-5.3,10.853,10.853,0,0,1,1.236-5.316,8.482,8.482,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.373,8.373,0,0,1,3.4,3.33,9.907,9.907,0,0,1,1.2,4.926A8.221,8.221,0,0,1,118.666,289.731Zm-6.879-5.383a3.781,3.781,0,0,0-2.631-.957,3.9,3.9,0,0,0-2.715.975,4.066,4.066,0,0,0-1.222,2.857h7.6A3.592,3.592,0,0,0,111.787,284.348Z",
    transform: "translate(-78.571 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M139.921,280.912a8.7,8.7,0,0,1,2.053,6.152v11.285h-5.92V287.761a3.965,3.965,0,0,0-.994-2.875,3.581,3.581,0,0,0-2.7-1.029,3.656,3.656,0,0,0-2.806,1.1,4.341,4.341,0,0,0-1.029,3.084v10.309h-5.955V287.761a4.009,4.009,0,0,0-.978-2.875,3.517,3.517,0,0,0-2.68-1.029,3.753,3.753,0,0,0-2.822,1.08,4.276,4.276,0,0,0-1.045,3.1v10.309h-5.959V278.912h5.959v3.307a5.8,5.8,0,0,1,2.35-2.578,7.158,7.158,0,0,1,3.709-.938,7.476,7.476,0,0,1,3.937,1.026,6.444,6.444,0,0,1,2.58,2.943,7.8,7.8,0,0,1,2.768-2.889,7.99,7.99,0,0,1,9.529,1.129Z",
    transform: "translate(-65.718 -273.719)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M141.385,279.889a8.265,8.265,0,0,1,3,3.447,13.388,13.388,0,0,1,0,10.611,8.234,8.234,0,0,1-3,3.465,7.85,7.85,0,0,1-4.3,1.2,7.018,7.018,0,0,1-3.832-1.013,5.85,5.85,0,0,1-2.334-2.75v12.783h-5.959v-28.7h5.959v3.516a5.872,5.872,0,0,1,2.334-2.75,7.018,7.018,0,0,1,3.832-1.01A7.85,7.85,0,0,1,141.385,279.889Zm-9.3,5.293a5.575,5.575,0,0,0,0,6.919,4.374,4.374,0,0,0,6.166.035,5.779,5.779,0,0,0,0-6.967,4,4,0,0,0-3.082-1.254A4.074,4.074,0,0,0,132.083,285.182Z",
    transform: "translate(-44.731 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M153.991,289.731h-13.48a4.517,4.517,0,0,0,1.112,3.154,3.6,3.6,0,0,0,2.58.957,3.543,3.543,0,0,0,2.195-.662,3.1,3.1,0,0,0,1.15-1.707h6.305a8.274,8.274,0,0,1-1.672,3.674,8.9,8.9,0,0,1-3.275,2.541,11.162,11.162,0,0,1-9.494-.276,8.583,8.583,0,0,1-3.465-3.465,10.736,10.736,0,0,1-1.254-5.3,10.879,10.879,0,0,1,1.236-5.316,8.5,8.5,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.373,8.373,0,0,1,3.4,3.33,9.884,9.884,0,0,1,1.2,4.926A8.239,8.239,0,0,1,153.991,289.731Zm-6.879-5.383a3.779,3.779,0,0,0-2.629-.957,3.9,3.9,0,0,0-2.717.975,4.067,4.067,0,0,0-1.222,2.857h7.6A3.584,3.584,0,0,0,147.112,284.348Z",
    transform: "translate(-31.855 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M153.244,279.746a7.36,7.36,0,0,1,3.816-1.043v6.373H155.35a5.874,5.874,0,0,0-3.674,1.013,4.052,4.052,0,0,0-1.305,3.414v8.846h-5.957V278.912h5.957v3.656A8.449,8.449,0,0,1,153.244,279.746Z",
    transform: "translate(-19.001 -273.719)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M162.732,279.7a6.08,6.08,0,0,1,2.369,2.75v-3.516h5.922v19.437H165.1v-3.516a6.056,6.056,0,0,1-2.369,2.75,7.016,7.016,0,0,1-3.83,1.013,7.853,7.853,0,0,1-4.3-1.2,8.2,8.2,0,0,1-3-3.465,13.362,13.362,0,0,1,0-10.611,8.232,8.232,0,0,1,3-3.447,7.852,7.852,0,0,1,4.3-1.2A7.015,7.015,0,0,1,162.732,279.7Zm-5,5.469a5.779,5.779,0,0,0,0,6.967,4.374,4.374,0,0,0,6.166-.035,5.583,5.583,0,0,0,0-6.919,4.074,4.074,0,0,0-3.084-1.268A4,4,0,0,0,157.734,285.168Z",
    transform: "translate(-10.947 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M172.97,295.826v5.121h-2.682a7.726,7.726,0,0,1-5.311-1.686c-1.266-1.131-1.9-2.991-1.9-5.595v-7.139h-2.613v-5.017h2.613v-4.773h5.957v4.773h3.9v5.017h-3.9v7.244a2.17,2.17,0,0,0,.471,1.6,2.234,2.234,0,0,0,1.584.453Z",
    transform: "translate(2.224 -276.318)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M186.784,278.793V298.23h-5.992v-3.516a6.5,6.5,0,0,1-2.492,2.717,7.255,7.255,0,0,1-3.848,1.008,6.722,6.722,0,0,1-5.314-2.227,8.961,8.961,0,0,1-1.969-6.134V278.793h5.925v10.556a4.344,4.344,0,0,0,1.029,3.084,3.612,3.612,0,0,0,2.768,1.094,3.661,3.661,0,0,0,2.854-1.147,4.7,4.7,0,0,0,1.047-3.277V278.793Z",
    transform: "translate(11.09 -273.6)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M186.215,279.746a7.36,7.36,0,0,1,3.816-1.043v6.373h-1.709a5.874,5.874,0,0,0-3.674,1.013,4.052,4.052,0,0,0-1.305,3.414v8.846h-5.96V278.912h5.96v3.656A8.449,8.449,0,0,1,186.215,279.746Z",
    transform: "translate(24.599 -273.719)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M202.774,289.731H189.292a4.517,4.517,0,0,0,1.112,3.154,3.6,3.6,0,0,0,2.58.957,3.538,3.538,0,0,0,2.195-.662,3.1,3.1,0,0,0,1.15-1.707h6.305a8.248,8.248,0,0,1-1.672,3.674,8.881,8.881,0,0,1-3.275,2.541,11.162,11.162,0,0,1-9.494-.276,8.6,8.6,0,0,1-3.465-3.465,10.761,10.761,0,0,1-1.254-5.3,10.879,10.879,0,0,1,1.236-5.316,8.509,8.509,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.359,8.359,0,0,1,3.4,3.33,9.884,9.884,0,0,1,1.2,4.926A8.406,8.406,0,0,1,202.774,289.731Zm-6.879-5.383a3.789,3.789,0,0,0-2.631-.957,3.9,3.9,0,0,0-2.717.975,4.065,4.065,0,0,0-1.219,2.857h7.594A3.591,3.591,0,0,0,195.895,284.348Z",
    transform: "translate(32.654 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M116.355,317.324l-2.857-3.446q-.348.557-.592.871a5.468,5.468,0,0,1-2.248,2.055,7.356,7.356,0,0,1-3.43.766,8.527,8.527,0,0,1-4.266-1.013,6.846,6.846,0,0,1-2.736-2.736,7.96,7.96,0,0,1-.941-3.883,7.511,7.511,0,0,1,1.6-4.961,6.149,6.149,0,0,1,4.111-2.25l-.418-.694a7.454,7.454,0,0,1-.836-1.742,6.2,6.2,0,0,1-.279-1.918,5.5,5.5,0,0,1,.836-2.926,5.979,5.979,0,0,1,2.455-2.176,8.531,8.531,0,0,1,3.885-.817,7.921,7.921,0,0,1,4.912,1.338,6.68,6.68,0,0,1,2.369,3.5,9.349,9.349,0,0,1,.383,3.379h-5.539c0-.395-.023-.82-.07-1.287q-.1-1.989-1.951-1.988a1.715,1.715,0,0,0-1.236.453,1.525,1.525,0,0,0-.471,1.152,2.277,2.277,0,0,0,.26,1.08,11.652,11.652,0,0,0,.855,1.289l12.193,15.953Zm-7.056-5.469a2.593,2.593,0,0,0,.785-1.951,2.624,2.624,0,0,0-.871-2.018,2.971,2.971,0,0,0-2.09-.8,2.772,2.772,0,0,0-1.967.7,2.564,2.564,0,0,0-.75,1.986,2.758,2.758,0,0,0,.818,2.074,2.89,2.89,0,0,0,2.074.78A2.743,2.743,0,0,0,109.3,311.855Z",
    transform: "translate(-78.682 -255.535)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M134.414,292.557v24.63h-5.992V306.912h-9.334v10.274h-5.959v-24.63h5.959V302.1h9.334v-9.548Z",
    transform: "translate(-60.374 -255.398)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M143.557,294.793V314.23h-5.992v-3.516a6.5,6.5,0,0,1-2.49,2.717,7.266,7.266,0,0,1-3.848,1.008,6.73,6.73,0,0,1-5.316-2.227,8.96,8.96,0,0,1-1.967-6.134V294.793h5.925v10.556a4.343,4.343,0,0,0,1.027,3.084,3.615,3.615,0,0,0,2.768,1.094,3.666,3.666,0,0,0,2.857-1.147,4.7,4.7,0,0,0,1.045-3.277V294.793Z",
    transform: "translate(-46.072 -252.441)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M164.99,296.912a8.7,8.7,0,0,1,2.055,6.152v11.285h-5.922V303.761a3.965,3.965,0,0,0-.994-2.875,3.581,3.581,0,0,0-2.7-1.029,3.656,3.656,0,0,0-2.806,1.1,4.34,4.34,0,0,0-1.026,3.084v10.309h-5.957V303.761a4,4,0,0,0-.978-2.875,3.517,3.517,0,0,0-2.68-1.029,3.753,3.753,0,0,0-2.822,1.08,4.276,4.276,0,0,0-1.045,3.1v10.309h-5.957V294.912h5.957v3.307a5.815,5.815,0,0,1,2.353-2.578,7.142,7.142,0,0,1,3.707-.938,7.485,7.485,0,0,1,3.939,1.027,6.453,6.453,0,0,1,2.578,2.943,7.813,7.813,0,0,1,2.768-2.889,7.99,7.99,0,0,1,9.529,1.129Z",
    transform: "translate(-32.563 -252.56)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M150.764,291.978a4.18,4.18,0,0,1,5.156,0,3.036,3.036,0,0,1,0,4.459,4.189,4.189,0,0,1-5.156,0,3.036,3.036,0,0,1,0-4.459Zm5.539,7.715v19.437h-5.957V299.693Z",
    transform: "translate(-11.893 -257.34)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M166.157,299.17a5.872,5.872,0,0,1,2.334,2.75v-9.857h5.957V317.84h-5.957v-3.516a5.85,5.85,0,0,1-2.334,2.75,7.019,7.019,0,0,1-3.832,1.013,7.85,7.85,0,0,1-4.3-1.2,8.2,8.2,0,0,1-3-3.465,13.362,13.362,0,0,1,0-10.611,8.233,8.233,0,0,1,3-3.447,7.849,7.849,0,0,1,4.3-1.2A7.018,7.018,0,0,1,166.157,299.17Zm-5,5.469a5.788,5.788,0,0,0,0,6.967,4.376,4.376,0,0,0,6.168-.035,5.584,5.584,0,0,0,0-6.919,4.074,4.074,0,0,0-3.084-1.268A4.007,4.007,0,0,0,161.156,304.639Z",
    transform: "translate(-6.418 -256.051)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M165.271,291.978a4.18,4.18,0,0,1,5.156,0,3.036,3.036,0,0,1,0,4.459,4.189,4.189,0,0,1-5.156,0,3.031,3.031,0,0,1,0-4.459Zm5.539,7.715v19.437h-5.957V299.693Z",
    transform: "translate(7.288 -257.34)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M180.73,311.826v5.121h-2.682a7.732,7.732,0,0,1-5.314-1.686c-1.263-1.131-1.9-2.991-1.9-5.595v-7.139h-2.613v-5.016h2.613v-4.773h5.957v4.773h3.9v5.016h-3.9v7.244a2.169,2.169,0,0,0,.471,1.6,2.23,2.23,0,0,0,1.584.453Z",
    transform: "translate(12.487 -255.158)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M180.773,294.793l4.668,11.912,4.355-11.912h6.584l-12.123,28.7h-6.549l4.561-10-8.15-18.707Z",
    transform: "translate(20.283 -252.441)",
    fill: "#004797"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(1013.416 10017.554)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564",
    transform: "translate(0 112.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M436.305,292.547v8.64h-5.959v-24.63H440q4.389,0,6.689,2.176a7.708,7.708,0,0,1,2.3,5.871,8.077,8.077,0,0,1-1.029,4.092,7.126,7.126,0,0,1-3.047,2.824A10.749,10.749,0,0,1,440,292.547Zm6.617-7.943q0-3.24-3.588-3.24h-3.028v6.41h3.028Q442.926,287.774,442.922,284.6Z",
    transform: "translate(-362.347 -276.557)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M454.472,279.889a8.81,8.81,0,0,1,3.588,3.465,11.393,11.393,0,0,1,0,10.59,8.829,8.829,0,0,1-3.588,3.467,11.759,11.759,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.467,11.393,11.393,0,0,1,0-10.59,8.784,8.784,0,0,1,3.607-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.047,5.188a5.024,5.024,0,0,0-1.168,3.574,4.944,4.944,0,0,0,1.168,3.551,3.82,3.82,0,0,0,2.873,1.219,3.768,3.768,0,0,0,2.859-1.219,4.991,4.991,0,0,0,1.149-3.551,5.072,5.072,0,0,0-1.149-3.574,3.75,3.75,0,0,0-2.859-1.236A3.8,3.8,0,0,0,446.424,285.077Z",
    transform: "translate(-350.642 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M478.734,278.792l-4.979,19.439H467.1L463.58,285.2l-3.551,13.029h-6.654l-4.984-19.439h5.957l2.58,14,3.621-14h6.343l3.725,14.039,2.58-14.039Z",
    transform: "translate(-338.483 -273.601)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M481.249,289.729H467.767a4.524,4.524,0,0,0,1.115,3.154,3.594,3.594,0,0,0,2.578.957,3.531,3.531,0,0,0,2.2-.662,3.091,3.091,0,0,0,1.15-1.707h6.306a8.272,8.272,0,0,1-1.672,3.674,8.931,8.931,0,0,1-3.275,2.543,11.162,11.162,0,0,1-9.494-.276,8.588,8.588,0,0,1-3.465-3.467,10.728,10.728,0,0,1-1.254-5.293,10.848,10.848,0,0,1,1.235-5.316,8.468,8.468,0,0,1,3.465-3.447,11.457,11.457,0,0,1,10.175-.019,8.368,8.368,0,0,1,3.4,3.328,9.893,9.893,0,0,1,1.2,4.928A8.211,8.211,0,0,1,481.249,289.729Zm-6.879-5.381a3.783,3.783,0,0,0-2.631-.959,3.906,3.906,0,0,0-2.715.975,4.075,4.075,0,0,0-1.222,2.857h7.6A3.587,3.587,0,0,0,474.37,284.348Z",
    transform: "translate(-320.549 -273.739)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M480.5,279.747a7.363,7.363,0,0,1,3.816-1.045v6.375H482.61a5.889,5.889,0,0,0-3.674,1.01,4.06,4.06,0,0,0-1.305,3.416v8.846h-5.96V278.911h5.96v3.658A8.43,8.43,0,0,1,480.5,279.747Z",
    transform: "translate(-307.696 -273.72)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M420.836,294.928a11.306,11.306,0,0,1,3.988,6.686h-6.306a5.782,5.782,0,0,0-2.141-2.682,5.993,5.993,0,0,0-3.433-.975,5.229,5.229,0,0,0-4.213,1.916,8.947,8.947,0,0,0,0,10.226,5.241,5.241,0,0,0,4.213,1.9,5.975,5.975,0,0,0,3.433-.975,5.807,5.807,0,0,0,2.141-2.648h6.306a11.369,11.369,0,0,1-3.988,6.672,11.988,11.988,0,0,1-7.785,2.49,12.294,12.294,0,0,1-6.308-1.586,10.754,10.754,0,0,1-4.2-4.441,15.083,15.083,0,0,1,0-13.029,10.782,10.782,0,0,1,4.2-4.44,12.294,12.294,0,0,1,6.308-1.586A12.046,12.046,0,0,1,420.836,294.928Z",
    transform: "translate(-401.067 -255.537)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M427.576,295.889a8.794,8.794,0,0,1,3.588,3.465,11.375,11.375,0,0,1,0,10.59,8.814,8.814,0,0,1-3.588,3.467,11.76,11.76,0,0,1-10.363,0,8.8,8.8,0,0,1-3.6-3.467,11.375,11.375,0,0,1,0-10.59,8.779,8.779,0,0,1,3.6-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.045,5.188a5.023,5.023,0,0,0-1.168,3.574,4.943,4.943,0,0,0,1.168,3.551,3.815,3.815,0,0,0,2.873,1.219,3.766,3.766,0,0,0,2.857-1.219,4.99,4.99,0,0,0,1.15-3.551,5.071,5.071,0,0,0-1.15-3.574,3.748,3.748,0,0,0-2.857-1.236A3.8,3.8,0,0,0,419.531,301.077Z",
    transform: "translate(-386.21 -252.579)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M439.965,296.931a8.947,8.947,0,0,1,1.969,6.131V314.35h-5.957V303.762a4.281,4.281,0,0,0-1.029-3.049,3.569,3.569,0,0,0-2.736-1.1,3.72,3.72,0,0,0-2.873,1.152,4.655,4.655,0,0,0-1.061,3.272V314.35h-5.957V294.911h5.957v3.553a6.438,6.438,0,0,1,2.49-2.752,7.331,7.331,0,0,1,3.885-1.01A6.727,6.727,0,0,1,439.965,296.931Z",
    transform: "translate(-372.959 -252.561)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M445.853,296.532a8.042,8.042,0,0,1,2.771,4.877h-5.576a3.093,3.093,0,0,0-1.094-1.865,3.357,3.357,0,0,0-2.144-.678,2.342,2.342,0,0,0-1.533.437,1.514,1.514,0,0,0-.523,1.236,1.45,1.45,0,0,0,.957,1.359,15.084,15.084,0,0,0,3.015.906,29.446,29.446,0,0,1,3.656,1.064,6.039,6.039,0,0,1,2.476,1.758A4.874,4.874,0,0,1,448.9,308.9a5.008,5.008,0,0,1-.908,2.961,5.963,5.963,0,0,1-2.613,2.021,10.189,10.189,0,0,1-4.039.734,10.4,10.4,0,0,1-6.305-1.742,7.337,7.337,0,0,1-2.892-4.984h5.748a2.58,2.58,0,0,0,1.064,1.916,3.991,3.991,0,0,0,2.385.662,2.21,2.21,0,0,0,1.533-.471,1.586,1.586,0,0,0,.523-1.235,1.487,1.487,0,0,0-.957-1.445,17.527,17.527,0,0,0-3.119-.922,25.032,25.032,0,0,1-3.556-.978,5.862,5.862,0,0,1-2.4-1.688,4.709,4.709,0,0,1-1.008-3.189,5.2,5.2,0,0,1,1.983-4.232,8.657,8.657,0,0,1,5.609-1.619A8.918,8.918,0,0,1,445.853,296.532Z",
    transform: "translate(-359.966 -252.579)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M460.281,294.792v19.439h-5.992v-3.518a6.476,6.476,0,0,1-2.492,2.717,7.235,7.235,0,0,1-3.848,1.01,6.727,6.727,0,0,1-5.314-2.23,8.955,8.955,0,0,1-1.969-6.131V294.792h5.925v10.556a4.341,4.341,0,0,0,1.029,3.084,3.617,3.617,0,0,0,2.768,1.1,3.666,3.666,0,0,0,2.854-1.147,4.7,4.7,0,0,0,1.047-3.277V294.792Z",
    transform: "translate(-348.7 -252.442)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M481.713,296.913a8.692,8.692,0,0,1,2.053,6.15V314.35h-5.92V303.762a3.974,3.974,0,0,0-.994-2.878,3.579,3.579,0,0,0-2.7-1.027,3.656,3.656,0,0,0-2.806,1.1,4.335,4.335,0,0,0-1.029,3.082V314.35h-5.955V303.762a4.018,4.018,0,0,0-.978-2.878,3.515,3.515,0,0,0-2.68-1.027,3.745,3.745,0,0,0-2.822,1.08,4.274,4.274,0,0,0-1.045,3.1V314.35H450.88V294.911h5.959v3.31a5.785,5.785,0,0,1,2.35-2.578,7.135,7.135,0,0,1,3.709-.941,7.477,7.477,0,0,1,3.937,1.029,6.432,6.432,0,0,1,2.58,2.943,7.818,7.818,0,0,1,2.768-2.891,7.986,7.986,0,0,1,9.529,1.131Z",
    transform: "translate(-335.191 -252.561)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M483.177,295.889a8.249,8.249,0,0,1,3,3.447,13.382,13.382,0,0,1,0,10.609,8.238,8.238,0,0,1-3,3.467,7.87,7.87,0,0,1-4.3,1.2,7.032,7.032,0,0,1-3.832-1.013,5.866,5.866,0,0,1-2.334-2.752v12.785H466.75V294.93h5.959v3.519a5.878,5.878,0,0,1,2.334-2.752,7.03,7.03,0,0,1,3.832-1.008A7.849,7.849,0,0,1,483.177,295.889Zm-9.3,5.293a5.572,5.572,0,0,0,0,6.916,4.371,4.371,0,0,0,6.166.037,5.778,5.778,0,0,0,0-6.967,4,4,0,0,0-3.082-1.254A4.065,4.065,0,0,0,473.875,301.182Z",
    transform: "translate(-314.204 -252.579)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M488.783,311.828v5.121H486.1a7.719,7.719,0,0,1-5.311-1.688q-1.9-1.693-1.9-5.592v-7.142h-2.613V297.51h2.613v-4.773h5.955v4.773h3.9v5.017h-3.9v7.246a2.183,2.183,0,0,0,.471,1.6,2.241,2.241,0,0,0,1.586.453Z",
    transform: "translate(-301.606 -255.16)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M483.838,291.977a4.177,4.177,0,0,1,5.154,0,2.906,2.906,0,0,1,.975,2.248,2.87,2.87,0,0,1-.975,2.211,4.186,4.186,0,0,1-5.154,0,2.865,2.865,0,0,1-.978-2.211A2.9,2.9,0,0,1,483.838,291.977Zm5.537,7.715v19.439h-5.957V299.692Z",
    transform: "translate(-292.899 -257.342)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M502.277,295.889a8.8,8.8,0,0,1,3.586,3.465,11.376,11.376,0,0,1,0,10.59,8.822,8.822,0,0,1-3.586,3.467,11.76,11.76,0,0,1-10.363,0,8.79,8.79,0,0,1-3.607-3.467,11.376,11.376,0,0,1,0-10.59,8.77,8.77,0,0,1,3.607-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.047,5.188a5.023,5.023,0,0,0-1.168,3.574,4.943,4.943,0,0,0,1.168,3.551,3.819,3.819,0,0,0,2.873,1.219,3.766,3.766,0,0,0,2.857-1.219,4.98,4.98,0,0,0,1.152-3.551,5.061,5.061,0,0,0-1.152-3.574,3.748,3.748,0,0,0-2.857-1.236A3.8,3.8,0,0,0,494.23,301.077Z",
    transform: "translate(-287.424 -252.579)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M514.666,296.931a8.959,8.959,0,0,1,1.967,6.131V314.35h-5.957V303.762a4.281,4.281,0,0,0-1.029-3.049,3.564,3.564,0,0,0-2.734-1.1,3.722,3.722,0,0,0-2.875,1.152,4.655,4.655,0,0,0-1.061,3.272V314.35H497.02V294.911h5.957v3.553a6.442,6.442,0,0,1,2.492-2.752,7.317,7.317,0,0,1,3.883-1.01A6.735,6.735,0,0,1,514.666,296.931Z",
    transform: "translate(-274.173 -252.561)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(75.059)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1041",
    "data-name": "Rectangle 1041",
    width: 92.898,
    height: 7.609,
    rx: 1.156,
    transform: "translate(0 81.868)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M511.208,251.825v52.7H437.52v-52.7l36.831-19.958Z",
    transform: "translate(-427.918 -222.659)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M526.279,253.718v7.622l-9.6-5.19L479.82,236.192,442.988,256.15l-9.6,5.19v-7.622L479.82,228.6Z",
    transform: "translate(-433.386 -226.984)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565",
    transform: "translate(15.306 22.509)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1042",
    "data-name": "Rectangle 1042",
    width: 25.692,
    height: 38.992,
    rx: 0.945,
    transform: "translate(18.295 7.065)",
    fill: "#e1e1e2",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M461.828,239.789v4.87h-10.76v-4.87a2.205,2.205,0,0,1,2.195-2.195h6.4A2.182,2.182,0,0,1,461.828,239.789Z",
    transform: "translate(-425.307 -237.594)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M457.164,260.682l.376-5.262-7.013-2.162,6.637-7.424-.376,5.262,7.013,2.162Z",
    transform: "translate(-426.023 -226.697)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    x1: 12.715,
    transform: "translate(5.58 38.979)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M446.388,256.2A3.206,3.206,0,1,1,443.181,253,3.206,3.206,0,0,1,446.388,256.2Z",
    transform: "translate(-439.976 -217.224)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    x2: 12.715,
    transform: "translate(43.987 31.277)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M464.032,252.887a3.206,3.206,0,1,0,3.207-3.207A3.208,3.208,0,0,0,464.032,252.887Z",
    transform: "translate(-408.163 -221.611)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    y1: 8.94,
    transform: "translate(71.105 6.007)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M465.712,233.91a3,3,0,1,0-3-3.005A3,3,0,0,0,465.712,233.91Z",
    transform: "translate(-394.607 -227.902)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(378.142 10383.038)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571",
    transform: "translate(0 112.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M143.083,403.982v24.46h-5.957v-15.3l-5.3,15.3h-5.156l-5.328-15.328v15.328h-5.959v-24.46h7.281l6.654,17.038,6.517-17.038Z",
    transform: "translate(-115.388 -400.396)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M143.924,407.242a8.764,8.764,0,0,1,3.588,3.465,11.384,11.384,0,0,1,0,10.586,8.825,8.825,0,0,1-3.588,3.472,11.78,11.78,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.472,11.384,11.384,0,0,1,0-10.586,8.74,8.74,0,0,1,3.607-3.465,11.76,11.76,0,0,1,10.363,0Zm-8.047,5.188a5.007,5.007,0,0,0-1.168,3.57,4.936,4.936,0,0,0,1.168,3.551,3.8,3.8,0,0,0,2.873,1.222,3.753,3.753,0,0,0,2.859-1.222,4.983,4.983,0,0,0,1.15-3.551,5.055,5.055,0,0,0-1.15-3.57,3.744,3.744,0,0,0-2.859-1.238A3.8,3.8,0,0,0,135.876,412.43Z",
    transform: "translate(-97.851 -397.676)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M150.53,423.181V428.3h-2.685a7.71,7.71,0,0,1-5.311-1.693q-1.9-1.686-1.9-5.588v-7.144h-2.613v-5.017h2.613v-4.773h5.955v4.773h3.9v5.017h-3.9v7.248a2.181,2.181,0,0,0,.471,1.6,2.24,2.24,0,0,0,1.586.455Z",
    transform: "translate(-85.453 -400.256)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M145.586,403.325a4.185,4.185,0,0,1,5.154,0,2.915,2.915,0,0,1,.975,2.25,2.862,2.862,0,0,1-.975,2.209,4.177,4.177,0,0,1-5.154,0,2.857,2.857,0,0,1-.978-2.209A2.909,2.909,0,0,1,145.586,403.325Zm5.539,7.717v19.441h-5.959V411.043Z",
    transform: "translate(-76.746 -402.438)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M164.025,407.242a8.764,8.764,0,0,1,3.588,3.465,11.384,11.384,0,0,1,0,10.586,8.825,8.825,0,0,1-3.588,3.472,11.78,11.78,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.472,11.366,11.366,0,0,1,0-10.586,8.74,8.74,0,0,1,3.607-3.465,11.76,11.76,0,0,1,10.363,0Zm-8.047,5.188A5.007,5.007,0,0,0,154.81,416a4.936,4.936,0,0,0,1.168,3.551,3.8,3.8,0,0,0,2.873,1.222,3.76,3.76,0,0,0,2.859-1.222,4.983,4.983,0,0,0,1.15-3.551,5.055,5.055,0,0,0-1.15-3.57,3.751,3.751,0,0,0-2.859-1.238A3.8,3.8,0,0,0,155.978,412.43Z",
    transform: "translate(-71.271 -397.676)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M176.414,408.285a8.937,8.937,0,0,1,1.967,6.127V425.7h-5.957V415.111a4.279,4.279,0,0,0-1.029-3.047,3.564,3.564,0,0,0-2.734-1.1,3.73,3.73,0,0,0-2.875,1.152,4.652,4.652,0,0,0-1.061,3.27V425.7h-5.957V406.262h5.957v3.556a6.449,6.449,0,0,1,2.492-2.754,7.32,7.32,0,0,1,3.885-1.01A6.724,6.724,0,0,1,176.414,408.285Z",
    transform: "translate(-58.02 -397.657)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(12.23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M155.443,386.077a12.041,12.041,0,0,0,0-17.012",
    transform: "translate(-74.647 -333.968)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M158.374,392.773a18.051,18.051,0,0,0,0-25.545",
    transform: "translate(-70.771 -336.397)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M127.874,369.065a12.02,12.02,0,0,0,0,17.012",
    transform: "translate(-115.771 -333.968)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M125.949,367.228a18.052,18.052,0,0,0,0,25.545",
    transform: "translate(-120.654 -336.397)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(0.128)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M138,353.953H123.517a2.81,2.81,0,0,0-2.808,2.808v14.481",
    transform: "translate(-120.709 -353.953)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M170.441,371.241V356.761a2.808,2.808,0,0,0-2.808-2.808H153.155",
    transform: "translate(-77.8 -353.953)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M153.155,403.76h14.478a2.807,2.807,0,0,0,2.808-2.808V386.474",
    transform: "translate(-77.8 -310.945)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M120.709,386.474v14.478a2.808,2.808,0,0,0,2.808,2.808H138",
    transform: "translate(-120.709 -310.945)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1242",
    "data-name": "Path 1242",
    d: "M183.42,388.956a1.433,1.433,0,0,0-.548-.137.089.089,0,0,0-.06,0l-12.135-.265-2.028-.049-9.87-9.947.922-3.01a8.358,8.358,0,0,0,1,.1,8.349,8.349,0,1,0-3.911-1.027l-.755,2.466-15.923.1L129.1,387.748l.009.026a1.525,1.525,0,0,0,1.633,2.49,1.368,1.368,0,0,0,.481-.293.084.084,0,0,0,.042-.044l8.744-8.417,1.468-1.4,13.631.019-11.09,36.184-11.6-3.565a.084.084,0,0,0-.056-.021,1.374,1.374,0,0,0-.562-.044,1.526,1.526,0,0,0-.334,2.959l0,.025,14.594,4.455.9-2.917,4.264-13.932,23.7,24.04.026-.028a1.417,1.417,0,0,0,1.108.5,1.53,1.53,0,0,0,1.53-1.531,1.577,1.577,0,0,0-.474-1.108l-24.878-25.18,5.546-18.124,9.766,9.689,15.254.362.012-.026a1.525,1.525,0,0,0,.613-2.912Z",
    transform: "translate(-110.044 -347.066)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582",
    transform: "translate(703.272 10374.967)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    transform: "translate(0 128.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1243",
    "data-name": "Path 1243",
    d: "M267.961,403.908l6.027,18.536,6.025-18.536h6.377l-8.57,24.632h-7.7l-8.535-24.632Z",
    transform: "translate(-261.586 -400.496)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1244",
    "data-name": "Path 1244",
    d: "M273.991,403.326a4.189,4.189,0,0,1,5.156,0,2.915,2.915,0,0,1,.975,2.248,2.875,2.875,0,0,1-.975,2.211,4.18,4.18,0,0,1-5.156,0,2.867,2.867,0,0,1-.975-2.211A2.907,2.907,0,0,1,273.991,403.326Zm5.539,7.718v19.439h-5.957V411.044Z",
    transform: "translate(-246.47 -402.439)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1245",
    "data-name": "Path 1245",
    d: "M294.015,410.713a8.2,8.2,0,0,1,3,3.446,13.351,13.351,0,0,1,0,10.607,8.216,8.216,0,0,1-3,3.47,7.887,7.887,0,0,1-4.3,1.2,7.036,7.036,0,0,1-3.832-1.01,5.866,5.866,0,0,1-2.334-2.752v3.519h-5.957V403.414h5.957v9.857a5.872,5.872,0,0,1,2.334-2.75,7.037,7.037,0,0,1,3.832-1.01A7.85,7.85,0,0,1,294.015,410.713Zm-9.3,5.293a5.58,5.58,0,0,0,0,6.916,4.374,4.374,0,0,0,6.166.035,5.778,5.778,0,0,0,0-6.967,4.01,4.01,0,0,0-3.082-1.254A4.068,4.068,0,0,0,284.714,416.006Z",
    transform: "translate(-240.42 -401.15)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1246",
    "data-name": "Path 1246",
    d: "M296.591,407.1a7.341,7.341,0,0,1,3.816-1.045v6.375H298.7a5.884,5.884,0,0,0-3.674,1.008,4.064,4.064,0,0,0-1.308,3.416V425.7h-5.957V406.263h5.957v3.658A8.45,8.45,0,0,1,296.591,407.1Z",
    transform: "translate(-226.971 -397.658)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1247",
    "data-name": "Path 1247",
    d: "M306.079,407.049a6.1,6.1,0,0,1,2.371,2.75v-3.516h5.92v19.439h-5.92V422.2a6.093,6.093,0,0,1-2.371,2.752,7.035,7.035,0,0,1-3.83,1.01,7.889,7.889,0,0,1-4.3-1.2,8.216,8.216,0,0,1-3-3.47,13.351,13.351,0,0,1,0-10.607,8.2,8.2,0,0,1,3-3.447,7.852,7.852,0,0,1,4.3-1.2A7.035,7.035,0,0,1,306.079,407.049Zm-5,5.469a5.779,5.779,0,0,0,0,6.967,4.374,4.374,0,0,0,6.166-.035,5.572,5.572,0,0,0,0-6.916,4.068,4.068,0,0,0-3.084-1.27A4.01,4.01,0,0,0,301.081,412.519Z",
    transform: "translate(-218.917 -397.678)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1248",
    "data-name": "Path 1248",
    d: "M316.318,423.18V428.3h-2.683a7.716,7.716,0,0,1-5.311-1.691q-1.9-1.69-1.9-5.59v-7.142h-2.613v-5.016h2.613v-4.773h5.957v4.773h3.9v5.016h-3.9v7.246a2.167,2.167,0,0,0,.471,1.6,2.236,2.236,0,0,0,1.586.455Z",
    transform: "translate(-205.745 -400.257)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1249",
    "data-name": "Path 1249",
    d: "M311.373,403.326a4.189,4.189,0,0,1,5.156,0,2.915,2.915,0,0,1,.975,2.248,2.875,2.875,0,0,1-.975,2.211,4.18,4.18,0,0,1-5.156,0,2.869,2.869,0,0,1-.978-2.211A2.909,2.909,0,0,1,311.373,403.326Zm5.539,7.718v19.439h-5.957V411.044Z",
    transform: "translate(-197.038 -402.439)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1250",
    "data-name": "Path 1250",
    d: "M329.811,407.242a8.779,8.779,0,0,1,3.588,3.465,11.371,11.371,0,0,1,0,10.588,8.819,8.819,0,0,1-3.588,3.47,11.78,11.78,0,0,1-10.363,0,8.788,8.788,0,0,1-3.6-3.47,11.371,11.371,0,0,1,0-10.588,8.748,8.748,0,0,1,3.6-3.465,11.76,11.76,0,0,1,10.363,0Zm-8.047,5.188A5.013,5.013,0,0,0,320.6,416a4.936,4.936,0,0,0,1.168,3.551,3.814,3.814,0,0,0,2.875,1.222,3.76,3.76,0,0,0,2.857-1.222,4.982,4.982,0,0,0,1.15-3.551,5.061,5.061,0,0,0-1.15-3.572,3.741,3.741,0,0,0-2.857-1.236A3.794,3.794,0,0,0,321.763,412.43Z",
    transform: "translate(-191.562 -397.678)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1251",
    "data-name": "Path 1251",
    d: "M342.2,408.284a8.937,8.937,0,0,1,1.969,6.129V425.7H338.21v-10.59a4.278,4.278,0,0,0-1.026-3.047,3.561,3.561,0,0,0-2.736-1.1,3.727,3.727,0,0,0-2.873,1.15,4.647,4.647,0,0,0-1.061,3.272V425.7h-5.957V406.263h5.957v3.553a6.442,6.442,0,0,1,2.49-2.754,7.331,7.331,0,0,1,3.885-1.008A6.726,6.726,0,0,1,342.2,408.284Z",
    transform: "translate(-178.311 -397.658)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(35.863)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(10.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577",
    transform: "translate(3.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1252",
    "data-name": "Path 1252",
    d: "M315.393,417.677a32.288,32.288,0,0,1-32.252-32.252v-32.44a6.028,6.028,0,0,1,12.056,0v32.44a20.2,20.2,0,1,0,40.395,0v-32.44a6.028,6.028,0,0,1,12.056,0v32.44a32.29,32.29,0,0,1-32.254,32.252Z",
    transform: "translate(-283.141 -346.958)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578",
    transform: "translate(3.419)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1253",
    "data-name": "Path 1253",
    d: "M295.2,361.68v-8.7a6.028,6.028,0,0,0-12.056,0v8.7Z",
    transform: "translate(-283.141 -346.958)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1254",
    "data-name": "Path 1254",
    d: "M317.781,361.68v-8.7a6.028,6.028,0,0,0-12.056,0v8.7Z",
    transform: "translate(-253.274 -346.958)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1255",
    "data-name": "Path 1255",
    d: "M303.735,413.782V373.406a4.273,4.273,0,1,0-8.547,0v40.376Z",
    transform: "translate(-263.791 -317.636)",
    fill: "#004797",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1256",
    "data-name": "Path 1256",
    d: "M350.82,398.683H283.859a2.189,2.189,0,0,1-2.19-2.19v-4.431a4.383,4.383,0,0,1,4.382-4.383h62.576a4.384,4.384,0,0,1,4.385,4.383v4.431a2.191,2.191,0,0,1-2.192,2.19Z",
    transform: "translate(-281.669 -293.106)",
    fill: "#fff",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580",
    transform: "translate(0 8.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1257",
    "data-name": "Path 1257",
    d: "M279.659,350.56a4.25,4.25,0,0,1-1.029,2.85,7.621,7.621,0,0,0,0,9.35,4.461,4.461,0,0,1,0,5.7,7.625,7.625,0,0,0,0,9.353,4.25,4.25,0,0,1,1.029,2.85",
    transform: "translate(-277.028 -350.56)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1258",
    "data-name": "Path 1258",
    d: "M315.9,380.661a4.25,4.25,0,0,1,1.027-2.85,7.621,7.621,0,0,0,0-9.35,4.469,4.469,0,0,1,0-5.7,7.624,7.624,0,0,0,0-9.353,4.25,4.25,0,0,1-1.027-2.85",
    transform: "translate(-225.627 -350.56)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(997.274 10387.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_584",
    "data-name": "Group 584",
    transform: "translate(0 92.058)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1259",
    "data-name": "Path 1259",
    d: "M414.863,422.6a10.862,10.862,0,0,1-4.459,4.373,14.232,14.232,0,0,1-6.847,1.568h-9.3V403.908h9.3a14.487,14.487,0,0,1,6.863,1.533,10.716,10.716,0,0,1,4.443,4.322,14.071,14.071,0,0,1,0,12.836Zm-6.412-1.236a7.931,7.931,0,0,0,0-10.381,7.526,7.526,0,0,0-5.416-1.849h-2.822V423.21h2.822A7.525,7.525,0,0,0,408.451,421.364Z",
    transform: "translate(-394.256 -395.445)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1260",
    "data-name": "Path 1260",
    d: "M405.989,403.326a4.186,4.186,0,0,1,5.154,0,2.907,2.907,0,0,1,.975,2.248,2.867,2.867,0,0,1-.975,2.211,4.177,4.177,0,0,1-5.154,0,2.861,2.861,0,0,1-.978-2.211A2.9,2.9,0,0,1,405.989,403.326Zm5.537,7.718v19.439h-5.957V411.044Z",
    transform: "translate(-380.033 -397.388)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1261",
    "data-name": "Path 1261",
    d: "M422.98,407.885a8.021,8.021,0,0,1,2.768,4.877h-5.574a3.1,3.1,0,0,0-1.1-1.865,3.339,3.339,0,0,0-2.144-.678,2.342,2.342,0,0,0-1.533.434,1.522,1.522,0,0,0-.523,1.238,1.451,1.451,0,0,0,.959,1.359,15.285,15.285,0,0,0,3.012.9,30.454,30.454,0,0,1,3.658,1.064,6.016,6.016,0,0,1,2.473,1.76,4.855,4.855,0,0,1,1.045,3.272,5.025,5.025,0,0,1-.906,2.963,5.964,5.964,0,0,1-2.613,2.021,10.21,10.21,0,0,1-4.041.732,10.394,10.394,0,0,1-6.3-1.742,7.348,7.348,0,0,1-2.894-4.982h5.748a2.585,2.585,0,0,0,1.064,1.916,4.013,4.013,0,0,0,2.385.662,2.221,2.221,0,0,0,1.535-.471,1.592,1.592,0,0,0,.52-1.236,1.488,1.488,0,0,0-.957-1.445,17.614,17.614,0,0,0-3.119-.924,24.6,24.6,0,0,1-3.553-.978,5.836,5.836,0,0,1-2.4-1.686,4.711,4.711,0,0,1-1.01-3.189,5.2,5.2,0,0,1,1.986-4.234,8.653,8.653,0,0,1,5.609-1.619A8.926,8.926,0,0,1,422.98,407.885Z",
    transform: "translate(-374.399 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1262",
    "data-name": "Path 1262",
    d: "M429.771,423.18V428.3h-2.682a7.72,7.72,0,0,1-5.311-1.691q-1.9-1.69-1.9-5.59v-7.142h-2.613v-5.016h2.613v-4.773h5.955v4.773h3.9v5.016h-3.9v7.246a2.167,2.167,0,0,0,.471,1.6,2.236,2.236,0,0,0,1.586.455Z",
    transform: "translate(-363.825 -395.206)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1263",
    "data-name": "Path 1263",
    d: "M435.884,407.049a6.079,6.079,0,0,1,2.369,2.75v-3.516h5.922v19.439h-5.922V422.2a6.073,6.073,0,0,1-2.369,2.752,7.037,7.037,0,0,1-3.832,1.01,7.888,7.888,0,0,1-4.3-1.2,8.2,8.2,0,0,1-3-3.47,13.351,13.351,0,0,1,0-10.607,8.189,8.189,0,0,1,3-3.447,7.85,7.85,0,0,1,4.3-1.2A7.037,7.037,0,0,1,435.884,407.049Zm-5,5.469a5.787,5.787,0,0,0,0,6.967,4.376,4.376,0,0,0,6.169-.035,5.58,5.58,0,0,0,0-6.916,4.068,4.068,0,0,0-3.084-1.27A4.015,4.015,0,0,0,430.884,412.519Z",
    transform: "translate(-355.376 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1264",
    "data-name": "Path 1264",
    d: "M451.9,408.284a8.937,8.937,0,0,1,1.969,6.129V425.7h-5.957v-10.59a4.279,4.279,0,0,0-1.029-3.047,3.561,3.561,0,0,0-2.736-1.1,3.726,3.726,0,0,0-2.873,1.15,4.647,4.647,0,0,0-1.061,3.272V425.7h-5.957V406.263h5.957v3.553a6.443,6.443,0,0,1,2.49-2.754,7.33,7.33,0,0,1,3.886-1.008A6.726,6.726,0,0,1,451.9,408.284Z",
    transform: "translate(-341.351 -392.607)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1265",
    "data-name": "Path 1265",
    d: "M460.058,408.113a9.171,9.171,0,0,1,3.2,5.695h-6.306a3.319,3.319,0,0,0-1.15-1.951,3.4,3.4,0,0,0-2.192-.7,3.182,3.182,0,0,0-2.578,1.236,6.926,6.926,0,0,0,0,7.211,3.185,3.185,0,0,0,2.578,1.238,3.384,3.384,0,0,0,2.192-.7,3.312,3.312,0,0,0,1.15-1.951h6.306a9.189,9.189,0,0,1-3.2,5.7,9.655,9.655,0,0,1-6.3,2.072,10.471,10.471,0,0,1-5.07-1.2,8.578,8.578,0,0,1-3.465-3.47A10.719,10.719,0,0,1,443.966,416a10.858,10.858,0,0,1,1.236-5.314,8.454,8.454,0,0,1,3.465-3.447,10.532,10.532,0,0,1,5.089-1.2A9.632,9.632,0,0,1,460.058,408.113Z",
    transform: "translate(-328.517 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1266",
    "data-name": "Path 1266",
    d: "M472.473,417.082h-13.48a4.5,4.5,0,0,0,1.112,3.152,3.587,3.587,0,0,0,2.578.959,3.517,3.517,0,0,0,2.2-.664,3.078,3.078,0,0,0,1.15-1.7h6.306a8.286,8.286,0,0,1-1.672,3.674,8.933,8.933,0,0,1-3.275,2.543,11.185,11.185,0,0,1-9.494-.276,8.579,8.579,0,0,1-3.465-3.47A10.721,10.721,0,0,1,453.176,416a10.831,10.831,0,0,1,1.236-5.314,8.439,8.439,0,0,1,3.465-3.447,11.438,11.438,0,0,1,10.175-.019,8.362,8.362,0,0,1,3.4,3.326,9.9,9.9,0,0,1,1.2,4.928A8.222,8.222,0,0,1,472.473,417.082Zm-6.879-5.381a3.77,3.77,0,0,0-2.629-.959,3.906,3.906,0,0,0-2.717.973,4.085,4.085,0,0,0-1.222,2.859h7.6A3.576,3.576,0,0,0,465.594,411.7Z",
    transform: "translate(-316.337 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1267",
    "data-name": "Path 1267",
    d: "M479.83,400.264l-9.373,39.644h-5.746l9.371-39.644Z",
    transform: "translate(-301.082 -400.264)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1268",
    "data-name": "Path 1268",
    d: "M480.689,423.976h7.943v4.564h-13.9V403.908h5.959Z",
    transform: "translate(-287.832 -395.445)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1269",
    "data-name": "Path 1269",
    d: "M500.763,417.082H487.284a4.5,4.5,0,0,0,1.113,3.152,3.586,3.586,0,0,0,2.578.959,3.518,3.518,0,0,0,2.2-.664,3.078,3.078,0,0,0,1.15-1.7h6.306a8.283,8.283,0,0,1-1.672,3.674,8.931,8.931,0,0,1-3.275,2.543,11.186,11.186,0,0,1-9.494-.276,8.578,8.578,0,0,1-3.465-3.47A10.72,10.72,0,0,1,481.466,416a10.857,10.857,0,0,1,1.236-5.314,8.454,8.454,0,0,1,3.465-3.447,11.438,11.438,0,0,1,10.175-.019,8.363,8.363,0,0,1,3.4,3.326,9.906,9.906,0,0,1,1.2,4.928A8.229,8.229,0,0,1,500.763,417.082Zm-6.879-5.381a3.77,3.77,0,0,0-2.629-.959,3.907,3.907,0,0,0-2.717.973,4.086,4.086,0,0,0-1.222,2.859h7.6A3.576,3.576,0,0,0,493.884,411.7Z",
    transform: "translate(-278.924 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1270",
    "data-name": "Path 1270",
    d: "M501.108,419.765l4.215-13.621h6.34l-6.9,19.439H497.38l-6.9-19.439h6.343Z",
    transform: "translate(-267.004 -392.488)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1271",
    "data-name": "Path 1271",
    d: "M519.53,417.082H506.048a4.512,4.512,0,0,0,1.115,3.152,3.586,3.586,0,0,0,2.578.959,3.511,3.511,0,0,0,2.195-.664,3.093,3.093,0,0,0,1.152-1.7h6.3a8.256,8.256,0,0,1-1.67,3.674,8.932,8.932,0,0,1-3.275,2.543,11.186,11.186,0,0,1-9.494-.276,8.6,8.6,0,0,1-3.468-3.47,11.91,11.91,0,0,1-.016-10.607,8.438,8.438,0,0,1,3.465-3.447,11.437,11.437,0,0,1,10.175-.019,8.362,8.362,0,0,1,3.4,3.326,9.928,9.928,0,0,1,1.2,4.928A8.219,8.219,0,0,1,519.53,417.082Zm-6.879-5.381a3.78,3.78,0,0,0-2.631-.959,3.914,3.914,0,0,0-2.717.973,4.094,4.094,0,0,0-1.219,2.859h7.594A3.575,3.575,0,0,0,512.651,411.7Z",
    transform: "translate(-254.11 -392.627)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1272",
    "data-name": "Path 1272",
    d: "M515.909,403.414v25.779H509.95V403.414Z",
    transform: "translate(-241.255 -396.098)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_587",
    "data-name": "Group 587",
    transform: "translate(73.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_585",
    "data-name": "Group 585"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_78",
    "data-name": "Ellipse 78",
    cx: 6.159,
    cy: 6.159,
    r: 6.159,
    transform: "translate(7.82 7.822)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1273",
    "data-name": "Path 1273",
    d: "M453.843,374.619a13.967,13.967,0,0,1-3.133,8.793h-.026c0,.025-.026.051-.051.077l-10.781,12.92-10.576-12.692a13.819,13.819,0,0,1-3.391-9.1,13.979,13.979,0,1,1,27.958,0Z",
    transform: "translate(-425.885 -360.626)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M446.856,376.033a5.814,5.814,0,1,1,0,11.629",
    transform: "translate(-398.152 -340.251)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M434.3,392.669a5.814,5.814,0,0,1,0-11.629",
    transform: "translate(-422.451 -333.629)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x2: 34.725,
    transform: "translate(13.98 35.783)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    x2: 36.86,
    transform: "translate(11.845 47.411)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M452.671,391.86a5.815,5.815,0,0,0-5.815-5.813",
    transform: "translate(-398.152 -327.008)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    x1: 36.86,
    transform: "translate(11.845 59.039)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    y2: 12.975,
    transform: "translate(54.486 64.395)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M437.226,388.287a3.935,3.935,0,1,0,3.936-3.934A3.936,3.936,0,0,0,437.226,388.287Z",
    transform: "translate(-410.887 -329.248)",
    fill: "#004797",
    stroke: "#e1e1e2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_79",
    "data-name": "Ellipse 79",
    cx: 3.935,
    cy: 3.935,
    r: 3.935,
    transform: "translate(48.705 33.361)",
    fill: "#004797",
    stroke: "#e1e1e2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    "data-name": "Line 375",
    x1: 41.302,
    transform: "translate(52.721 77.37)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M447.651,396.18a3.934,3.934,0,1,0,3.934-3.934A3.934,3.934,0,0,0,447.651,396.18Z",
    transform: "translate(-397.1 -318.81)",
    fill: "#004797",
    stroke: "#e1e1e2",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_586",
    "data-name": "Group 586",
    transform: "translate(65.951 8.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M506.87,368.847a.155.155,0,0,1-.132.172H461.368a.157.157,0,0,1-.132-.172V365.56a.156.156,0,0,1,.132-.169h45.369a.154.154,0,0,1,.132.169Z",
    transform: "translate(-445.086 -362.441)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M506.87,373.464a.154.154,0,0,1-.132.17H461.368a.156.156,0,0,1-.132-.17v-3.286a.157.157,0,0,1,.132-.172h45.369a.155.155,0,0,1,.132.172Z",
    transform: "translate(-445.086 -356.338)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M506.87,378.078a.155.155,0,0,1-.132.172H461.368a.157.157,0,0,1-.132-.172v-3.286a.156.156,0,0,1,.132-.17h45.369a.154.154,0,0,1,.132.17Z",
    transform: "translate(-445.086 -350.234)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M506.87,382.7a.154.154,0,0,1-.132.17H461.368a.156.156,0,0,1-.132-.17v-3.286a.157.157,0,0,1,.132-.172h45.369a.155.155,0,0,1,.132.172Z",
    transform: "translate(-445.086 -344.131)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M506.87,387.309a.155.155,0,0,1-.132.172H461.368a.157.157,0,0,1-.132-.172v-3.286a.156.156,0,0,1,.132-.17h45.369a.154.154,0,0,1,.132.17Z",
    transform: "translate(-445.086 -338.026)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M460.158,388.6v15.711h-4.773V368.383h4.773v15.711",
    transform: "translate(-452.823 -358.485)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M459.229,364.121l4.949,5.9h-9.9Z",
    transform: "translate(-454.282 -364.121)",
    fill: "#e1e1e2",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M459.23,391.3l-4.947-5.9h9.894Z",
    transform: "translate(-454.282 -335.973)",
    fill: "#e1e1e2",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(1348.923 10373.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_590",
    "data-name": "Group 590",
    transform: "translate(0 132.845)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_589",
    "data-name": "Group 589"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M97.653,551.3H88.421l-1.533,4.492H80.618l9.02-24.455H96.5l9.023,24.455H99.186Zm-1.535-4.531-3.066-9.057-3.1,9.057Z",
    transform: "translate(-80.618 -530.014)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M107.993,535.463a9.186,9.186,0,0,1,3.2,5.695h-6.3a3.336,3.336,0,0,0-1.152-1.951,3.4,3.4,0,0,0-2.192-.694,3.176,3.176,0,0,0-2.578,1.236,6.922,6.922,0,0,0,0,7.209,3.18,3.18,0,0,0,2.578,1.24,3.4,3.4,0,0,0,2.192-.7,3.322,3.322,0,0,0,1.152-1.951h6.3a9.2,9.2,0,0,1-3.2,5.7,9.656,9.656,0,0,1-6.305,2.074,10.448,10.448,0,0,1-5.07-1.2,8.589,8.589,0,0,1-3.465-3.467,10.746,10.746,0,0,1-1.254-5.293,10.857,10.857,0,0,1,1.236-5.314,8.487,8.487,0,0,1,3.465-3.449,10.558,10.558,0,0,1,5.089-1.2A9.654,9.654,0,0,1,107.993,535.463Z",
    transform: "translate(-65.701 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M117.2,535.463a9.186,9.186,0,0,1,3.2,5.695h-6.3a3.348,3.348,0,0,0-1.152-1.951,3.4,3.4,0,0,0-2.192-.694,3.176,3.176,0,0,0-2.578,1.236,6.922,6.922,0,0,0,0,7.209,3.18,3.18,0,0,0,2.578,1.24,3.4,3.4,0,0,0,2.192-.7,3.334,3.334,0,0,0,1.152-1.951h6.3a9.2,9.2,0,0,1-3.2,5.7,9.656,9.656,0,0,1-6.305,2.074,10.448,10.448,0,0,1-5.07-1.2,8.589,8.589,0,0,1-3.465-3.467,10.746,10.746,0,0,1-1.254-5.293,10.858,10.858,0,0,1,1.236-5.314,8.487,8.487,0,0,1,3.465-3.449,10.558,10.558,0,0,1,5.088-1.2A9.654,9.654,0,0,1,117.2,535.463Z",
    transform: "translate(-53.521 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M129.615,544.432h-13.48a4.508,4.508,0,0,0,1.112,3.154,3.6,3.6,0,0,0,2.58.957,3.528,3.528,0,0,0,2.195-.662,3.091,3.091,0,0,0,1.15-1.707h6.306a8.294,8.294,0,0,1-1.672,3.676,8.929,8.929,0,0,1-3.275,2.541,10.337,10.337,0,0,1-4.424.926,10.448,10.448,0,0,1-5.07-1.2,8.589,8.589,0,0,1-3.465-3.467,10.721,10.721,0,0,1-1.254-5.293,10.858,10.858,0,0,1,1.236-5.314,8.487,8.487,0,0,1,3.465-3.449,11.457,11.457,0,0,1,10.175-.019,8.368,8.368,0,0,1,3.4,3.328,9.893,9.893,0,0,1,1.2,4.928A8.234,8.234,0,0,1,129.615,544.432Zm-6.879-5.381a3.78,3.78,0,0,0-2.629-.959,3.909,3.909,0,0,0-2.717.976,4.075,4.075,0,0,0-1.222,2.857h7.6A3.582,3.582,0,0,0,122.736,539.051Z",
    transform: "translate(-41.341 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M126,530.766v25.777h-5.957V530.766Z",
    transform: "translate(-28.487 -530.766)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M143.235,544.432h-13.48a4.508,4.508,0,0,0,1.112,3.154,3.6,3.6,0,0,0,2.58.957,3.523,3.523,0,0,0,2.195-.662,3.091,3.091,0,0,0,1.15-1.707H143.1a8.269,8.269,0,0,1-1.672,3.676,8.929,8.929,0,0,1-3.275,2.541,10.337,10.337,0,0,1-4.424.926,10.448,10.448,0,0,1-5.07-1.2,8.589,8.589,0,0,1-3.465-3.467,10.746,10.746,0,0,1-1.254-5.293,10.857,10.857,0,0,1,1.236-5.314,8.487,8.487,0,0,1,3.465-3.449,11.457,11.457,0,0,1,10.175-.019,8.367,8.367,0,0,1,3.4,3.328,9.893,9.893,0,0,1,1.2,4.928A8.23,8.23,0,0,1,143.235,544.432Zm-6.877-5.381a3.79,3.79,0,0,0-2.631-.959,3.909,3.909,0,0,0-2.717.976,4.075,4.075,0,0,0-1.222,2.857h7.6A3.589,3.589,0,0,0,136.359,539.051Z",
    transform: "translate(-23.329 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M142.488,534.45a7.364,7.364,0,0,1,3.816-1.045v6.375H144.6a5.884,5.884,0,0,0-3.674,1.01,4.06,4.06,0,0,0-1.308,3.416v8.846h-5.957V533.614h5.957v3.658A8.449,8.449,0,0,1,142.488,534.45Z",
    transform: "translate(-10.475 -527.276)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M155.025,534.592a8.808,8.808,0,0,1,3.588,3.465,11.394,11.394,0,0,1,0,10.591,8.83,8.83,0,0,1-3.588,3.467,11.761,11.761,0,0,1-10.363,0,8.805,8.805,0,0,1-3.607-3.467,11.376,11.376,0,0,1,0-10.591,8.783,8.783,0,0,1,3.607-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.047,5.191a5.013,5.013,0,0,0-1.168,3.572,4.94,4.94,0,0,0,1.168,3.551,3.811,3.811,0,0,0,2.873,1.219,3.767,3.767,0,0,0,2.859-1.219,4.986,4.986,0,0,0,1.15-3.551,5.061,5.061,0,0,0-1.15-3.572,3.751,3.751,0,0,0-2.859-1.238A3.8,3.8,0,0,0,146.978,539.782Z",
    transform: "translate(-2.421 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M180.6,535.616a8.694,8.694,0,0,1,2.055,6.15v11.287h-5.922V542.465a3.974,3.974,0,0,0-.992-2.878,3.582,3.582,0,0,0-2.7-1.026,3.661,3.661,0,0,0-2.808,1.1,4.343,4.343,0,0,0-1.027,3.082v10.312h-5.955V542.465a4.018,4.018,0,0,0-.978-2.878,3.52,3.52,0,0,0-2.682-1.026,3.739,3.739,0,0,0-2.819,1.08,4.274,4.274,0,0,0-1.047,3.1v10.312h-5.957V533.614h5.957v3.309a5.786,5.786,0,0,1,2.353-2.576,7.1,7.1,0,0,1,3.709-.943,7.482,7.482,0,0,1,3.937,1.029,6.452,6.452,0,0,1,2.578,2.942,7.845,7.845,0,0,1,2.771-2.891,7.983,7.983,0,0,1,9.527,1.131Z",
    transform: "translate(10.83 -527.276)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M184.5,544.432H171.019a4.519,4.519,0,0,0,1.115,3.154,3.6,3.6,0,0,0,2.578.957,3.53,3.53,0,0,0,2.2-.662,3.091,3.091,0,0,0,1.15-1.707h6.305a8.294,8.294,0,0,1-1.672,3.676,8.929,8.929,0,0,1-3.275,2.541,11.165,11.165,0,0,1-9.494-.276,8.589,8.589,0,0,1-3.465-3.467,10.721,10.721,0,0,1-1.254-5.293,10.832,10.832,0,0,1,1.236-5.314,8.459,8.459,0,0,1,3.465-3.449,11.457,11.457,0,0,1,10.175-.019,8.368,8.368,0,0,1,3.4,3.328,9.917,9.917,0,0,1,1.2,4.928A8.216,8.216,0,0,1,184.5,544.432Zm-6.879-5.381a3.782,3.782,0,0,0-2.631-.959,3.917,3.917,0,0,0-2.717.976,4.083,4.083,0,0,0-1.219,2.857h7.6A3.59,3.59,0,0,0,177.622,539.051Z",
    transform: "translate(31.244 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M186.785,550.531v5.121H184.1a7.72,7.72,0,0,1-5.311-1.688q-1.9-1.693-1.9-5.593v-7.142h-2.613v-5.016h2.613V531.44h5.955v4.773h3.9v5.016h-3.9v7.246a2.183,2.183,0,0,0,.471,1.6,2.241,2.241,0,0,0,1.586.453Z",
    transform: "translate(43.245 -529.875)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M199.968,544.432H186.486a4.519,4.519,0,0,0,1.115,3.154,3.6,3.6,0,0,0,2.578.957,3.523,3.523,0,0,0,2.195-.662,3.106,3.106,0,0,0,1.152-1.707h6.3a8.266,8.266,0,0,1-1.67,3.676,8.929,8.929,0,0,1-3.275,2.541,11.165,11.165,0,0,1-9.494-.276,8.609,8.609,0,0,1-3.467-3.467,11.909,11.909,0,0,1-.016-10.607,8.459,8.459,0,0,1,3.465-3.449,11.457,11.457,0,0,1,10.175-.019,8.368,8.368,0,0,1,3.4,3.328,9.916,9.916,0,0,1,1.2,4.928A8.219,8.219,0,0,1,199.968,544.432Zm-6.879-5.381a3.79,3.79,0,0,0-2.631-.959,3.917,3.917,0,0,0-2.717.976,4.083,4.083,0,0,0-1.219,2.857h7.594A3.581,3.581,0,0,0,193.089,539.051Z",
    transform: "translate(51.694 -527.294)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M199.22,534.45a7.362,7.362,0,0,1,3.813-1.045v6.375h-1.707a5.884,5.884,0,0,0-3.674,1.01,4.059,4.059,0,0,0-1.305,3.416v8.846h-5.959V533.614h5.959v3.658A8.449,8.449,0,0,1,199.22,534.45Z",
    transform: "translate(64.548 -527.276)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_596",
    "data-name": "Group 596",
    transform: "translate(79.832)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M190.2,508.776l-37.371,4.4-28.89-8.6,37.371-4.322Z",
    transform: "translate(-103.164 -438.266)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M190.2,492.862l-37.371,4.4-28.89-8.6,37.371-4.322Z",
    transform: "translate(-103.164 -459.312)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_591",
    "data-name": "Group 591",
    transform: "translate(20.772 25.032)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M161.307,521.715l-37.371,4.4V488.744l37.371-4.4Z",
    transform: "translate(-123.936 -484.344)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M173.746,525.383l-37.371,4.4V492.411l37.371-4.4Z",
    transform: "translate(-107.486 -479.494)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M152.826,532.123l-28.89-8.494V486.242l28.89,8.494Z",
    transform: "translate(-123.936 -481.835)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M168.917,530.226l-28.89-8.494V484.344l28.89,8.494Z",
    transform: "translate(-102.656 -484.344)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_595",
    "data-name": "Group 595"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_594",
    "data-name": "Group 594"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_592",
    "data-name": "Group 592",
    transform: "translate(0 50.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M179.944,496.147c9.8,2.926,15.862,6.991,15.862,11.45,0,8.941-24.2,16.188-54.044,16.188q-3.111,0-6.148-.1",
    transform: "translate(-87.719 -494.119)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M126.163,496.837c-7.014,2.74-11.171,6.155-11.171,9.847,0,7.076,15.163,13.087,36.288,15.3",
    transform: "translate(-114.992 -493.207)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M116.468,495.274l8.061,3.516-3.516,8.061",
    transform: "translate(-113.04 -495.274)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_593",
    "data-name": "Group 593",
    transform: "translate(39.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M160.482,492.188c-2.966-11.408-7.339-18.622-12.216-18.622-8.935,0-16.176,24.2-16.176,54.046s7.241,54.046,16.176,54.046c5.414,0,10.2-8.881,13.141-22.521",
    transform: "translate(-132.09 -473.566)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M152.9,478.445l-4.152,7.753L141,482.046",
    transform: "translate(-120.313 -467.113)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M141.236,494.721l-4.161-9.1,6.857-.774,6.207,1.887.387,6.871Z",
    transform: "translate(-85.788 -458.642)",
    fill: "#e1e1e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2477",
    "data-name": "Group 2477",
    transform: "translate(342.4 10722.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538",
    transform: "translate(0 115.958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M276.286,533.419a9.64,9.64,0,0,1,3.73,6.131H273.71a4.907,4.907,0,0,0-1.916-2.109,5.883,5.883,0,0,0-3.1-.783,5.792,5.792,0,0,0-4.529,1.9,7.389,7.389,0,0,0-1.709,5.14,7.52,7.52,0,0,0,1.8,5.4,6.721,6.721,0,0,0,5.1,1.881,6.034,6.034,0,0,0,5.992-4.494h-7.525V542.2h12.506v5.888a12.07,12.07,0,0,1-2.23,4.006,11.506,11.506,0,0,1-3.92,3,12.417,12.417,0,0,1-5.453,1.15,12.917,12.917,0,0,1-6.512-1.586,10.828,10.828,0,0,1-4.3-4.44,14.77,14.77,0,0,1,0-13.029,10.9,10.9,0,0,1,4.285-4.44,12.785,12.785,0,0,1,6.461-1.586A12.3,12.3,0,0,1,276.286,533.419Z",
    transform: "translate(-256.396 -531.155)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M273.866,533.495l4.666,11.914,4.355-11.914h6.584L277.35,562.2H270.8l4.564-10-8.152-18.707Z",
    transform: "translate(-242.095 -528.06)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M286.482,534.45a7.35,7.35,0,0,1,3.813-1.045v6.375h-1.707a5.883,5.883,0,0,0-3.674,1.01,4.06,4.06,0,0,0-1.308,3.416v8.846H277.65V533.614h5.957v3.658A8.476,8.476,0,0,1,286.482,534.45Z",
    transform: "translate(-228.288 -528.18)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M299.016,534.592a8.808,8.808,0,0,1,3.588,3.465,11.395,11.395,0,0,1,0,10.591,8.83,8.83,0,0,1-3.588,3.467,11.761,11.761,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.467,11.393,11.393,0,0,1,0-10.591,8.783,8.783,0,0,1,3.607-3.465,11.779,11.779,0,0,1,10.363,0Zm-8.047,5.191a5.013,5.013,0,0,0-1.168,3.572,4.94,4.94,0,0,0,1.168,3.551,3.811,3.811,0,0,0,2.873,1.219,3.763,3.763,0,0,0,2.859-1.219,4.986,4.986,0,0,0,1.15-3.551,5.061,5.061,0,0,0-1.15-3.572,3.748,3.748,0,0,0-2.859-1.238A3.8,3.8,0,0,0,290.968,539.782Z",
    transform: "translate(-220.233 -528.198)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M307.153,535.237a8.015,8.015,0,0,1,2.768,4.875h-5.574a3.084,3.084,0,0,0-1.1-1.865,3.347,3.347,0,0,0-2.141-.678,2.35,2.35,0,0,0-1.535.437,1.519,1.519,0,0,0-.52,1.236,1.447,1.447,0,0,0,.957,1.359,15.08,15.08,0,0,0,3.015.906,29.946,29.946,0,0,1,3.656,1.064,6,6,0,0,1,2.473,1.76A4.851,4.851,0,0,1,310.2,547.6a5.007,5.007,0,0,1-.908,2.961,5.962,5.962,0,0,1-2.613,2.021,10.192,10.192,0,0,1-4.039.734,10.4,10.4,0,0,1-6.305-1.742,7.338,7.338,0,0,1-2.892-4.984h5.746a2.584,2.584,0,0,0,1.064,1.916,4,4,0,0,0,2.388.664,2.215,2.215,0,0,0,1.533-.474,1.584,1.584,0,0,0,.52-1.235,1.484,1.484,0,0,0-.957-1.445,17.409,17.409,0,0,0-3.117-.922,24.941,24.941,0,0,1-3.556-.978,5.864,5.864,0,0,1-2.4-1.688,4.71,4.71,0,0,1-1.008-3.189,5.2,5.2,0,0,1,1.983-4.231,8.652,8.652,0,0,1,5.609-1.619A8.911,8.911,0,0,1,307.153,535.237Z",
    transform: "translate(-207.399 -528.198)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M317.743,535.463a9.177,9.177,0,0,1,3.2,5.695h-6.3a3.348,3.348,0,0,0-1.152-1.951,3.4,3.4,0,0,0-2.192-.694,3.175,3.175,0,0,0-2.578,1.236,6.922,6.922,0,0,0,0,7.209,3.18,3.18,0,0,0,2.578,1.24,3.4,3.4,0,0,0,2.192-.7,3.333,3.333,0,0,0,1.152-1.951h6.3a9.189,9.189,0,0,1-3.2,5.7,9.645,9.645,0,0,1-6.3,2.074,10.448,10.448,0,0,1-5.07-1.2,8.589,8.589,0,0,1-3.465-3.467,10.72,10.72,0,0,1-1.254-5.293,10.857,10.857,0,0,1,1.236-5.314,8.486,8.486,0,0,1,3.465-3.449,10.558,10.558,0,0,1,5.089-1.2A9.643,9.643,0,0,1,317.743,535.463Z",
    transform: "translate(-196.548 -528.198)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M326.136,534.592a8.808,8.808,0,0,1,3.588,3.465,11.394,11.394,0,0,1,0,10.591,8.83,8.83,0,0,1-3.588,3.467,11.761,11.761,0,0,1-10.363,0,8.805,8.805,0,0,1-3.607-3.467,11.393,11.393,0,0,1,0-10.591,8.783,8.783,0,0,1,3.607-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.047,5.191a5.013,5.013,0,0,0-1.168,3.572,4.94,4.94,0,0,0,1.168,3.551,3.811,3.811,0,0,0,2.873,1.219,3.76,3.76,0,0,0,2.859-1.219,4.986,4.986,0,0,0,1.15-3.551,5.061,5.061,0,0,0-1.15-3.572,3.744,3.744,0,0,0-2.859-1.238A3.8,3.8,0,0,0,318.088,539.782Z",
    transform: "translate(-184.368 -528.198)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M337.307,534.592a8.259,8.259,0,0,1,3,3.449,13.378,13.378,0,0,1,0,10.607,8.258,8.258,0,0,1-3,3.467,7.877,7.877,0,0,1-4.3,1.2,7.032,7.032,0,0,1-3.832-1.013,5.859,5.859,0,0,1-2.334-2.75v12.783H320.88V533.633h5.959v3.519a5.877,5.877,0,0,1,2.334-2.752,7.031,7.031,0,0,1,3.832-1.008A7.874,7.874,0,0,1,337.307,534.592Zm-9.3,5.3a5.568,5.568,0,0,0,0,6.914,4.371,4.371,0,0,0,6.166.037,5.779,5.779,0,0,0,0-6.967,4,4,0,0,0-3.082-1.254A4.056,4.056,0,0,0,328.005,539.887Z",
    transform: "translate(-171.118 -528.198)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M349.913,544.432h-13.48a4.508,4.508,0,0,0,1.113,3.154,3.594,3.594,0,0,0,2.578.957,3.53,3.53,0,0,0,2.2-.662,3.09,3.09,0,0,0,1.15-1.707h6.305a8.293,8.293,0,0,1-1.672,3.676,8.929,8.929,0,0,1-3.275,2.541,11.165,11.165,0,0,1-9.494-.276,8.589,8.589,0,0,1-3.465-3.467,10.722,10.722,0,0,1-1.254-5.293,10.831,10.831,0,0,1,1.236-5.314,8.459,8.459,0,0,1,3.465-3.449,11.457,11.457,0,0,1,10.175-.019,8.367,8.367,0,0,1,3.4,3.328,9.891,9.891,0,0,1,1.2,4.928A8.215,8.215,0,0,1,349.913,544.432Zm-6.879-5.381a3.782,3.782,0,0,0-2.631-.959,3.907,3.907,0,0,0-2.715.976,4.075,4.075,0,0,0-1.222,2.857h7.6A3.59,3.59,0,0,0,343.034,539.051Z",
    transform: "translate(-158.243 -528.198)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_598",
    "data-name": "Group 598",
    transform: "translate(49.334)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    x2: 7.581,
    y2: 7.581,
    transform: "translate(77.172 77.14)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    x2: 49.88,
    y2: 49.88,
    transform: "translate(21.516 21.485)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    x2: 7.608,
    y2: 7.607,
    transform: "translate(8.133 8.101)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M287.144,485.98a4.753,4.753,0,1,1-4.754-4.754A4.753,4.753,0,0,1,287.144,485.98Z",
    transform: "translate(-277.638 -481.226)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M323.052,521.872a4.754,4.754,0,1,1-4.754-4.754A4.754,4.754,0,0,1,323.052,521.872Z",
    transform: "translate(-230.154 -433.76)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 43.439,
    cy: 43.439,
    r: 43.439,
    transform: "translate(3.107 2.894)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_81",
    "data-name": "Ellipse 81",
    cx: 35.272,
    cy: 35.272,
    r: 35.272,
    transform: "translate(11.275 11.062)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M306.756,510.268c3.753-3.753,4.8-8.79,2.341-11.25s-7.5-1.412-11.25,2.343-4.8,8.791-2.343,11.25S303,514.024,306.756,510.268Z",
    transform: "translate(-255.771 -459.455)",
    fill: "#004797",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M322.885,526.4c10.421-10.421,13.333-24.4,6.5-31.232s-20.812-3.918-31.232,6.5-13.333,24.407-6.505,31.235S312.464,536.822,322.885,526.4Z",
    transform: "translate(-263.99 -467.676)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M298.156,526.4c-10.421-10.421-13.333-24.4-6.505-31.232s20.814-3.918,31.235,6.5,13.333,24.407,6.5,31.235S308.577,536.822,298.156,526.4Z",
    transform: "translate(-263.99 -467.676)",
    fill: "none",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(740.167 10724.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(7.483 118.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M452.668,531.261V536h-10.1v5.4h7.8v4.529h-7.8v9.964h-5.96v-24.63Z",
    transform: "translate(-436.608 -530.114)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M450.8,530.767v25.777h-5.957V530.767Z",
    transform: "translate(-425.716 -530.767)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M464.019,534.593a8.807,8.807,0,0,1,3.588,3.465,11.375,11.375,0,0,1,0,10.59,8.828,8.828,0,0,1-3.588,3.467,11.759,11.759,0,0,1-10.363,0,8.8,8.8,0,0,1-3.6-3.467,11.375,11.375,0,0,1,0-10.59,8.777,8.777,0,0,1,3.6-3.465,11.78,11.78,0,0,1,10.363,0Zm-8.047,5.191a5.014,5.014,0,0,0-1.168,3.572,4.939,4.939,0,0,0,1.168,3.551,3.821,3.821,0,0,0,2.875,1.219,3.767,3.767,0,0,0,2.857-1.219,4.986,4.986,0,0,0,1.15-3.551,5.061,5.061,0,0,0-1.15-3.572,3.743,3.743,0,0,0-2.857-1.238A3.8,3.8,0,0,0,455.971,539.783Z",
    transform: "translate(-420.559 -527.296)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M488.283,533.5,483.3,552.935h-6.654l-3.521-13.029-3.551,13.029h-6.654L457.938,533.5H463.9l2.578,14,3.623-14h6.34l3.728,14.039,2.578-14.039Z",
    transform: "translate(-408.4 -527.158)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    x1: 72.888,
    transform: "translate(13.295 48.181)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M446.682,486.3a6.648,6.648,0,1,1-6.649-6.649A6.649,6.649,0,0,1,446.682,486.3Z",
    transform: "translate(-433.386 -479.646)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M446.682,495.255a6.648,6.648,0,1,1-6.649-6.649A6.648,6.648,0,0,1,446.682,495.255Z",
    transform: "translate(-433.386 -467.797)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M446.682,504.214a6.648,6.648,0,1,1-6.649-6.647A6.648,6.648,0,0,1,446.682,504.214Z",
    transform: "translate(-433.386 -455.946)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M446.682,513.174a6.648,6.648,0,1,1-6.649-6.647A6.65,6.65,0,0,1,446.682,513.174Z",
    transform: "translate(-433.386 -444.097)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M446.682,522.136a6.648,6.648,0,1,1-6.649-6.649A6.649,6.649,0,0,1,446.682,522.136Z",
    transform: "translate(-433.386 -432.248)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    x2: 37.836,
    transform: "translate(13.295 27.458)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x2: 37.836,
    transform: "translate(13.295 69.078)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M458.35,513.1a6.648,6.648,0,1,1-6.647-6.649A6.646,6.646,0,0,1,458.35,513.1Z",
    transform: "translate(-417.956 -444.196)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M458.35,504.214a6.648,6.648,0,1,1-6.647-6.647A6.646,6.646,0,0,1,458.35,504.214Z",
    transform: "translate(-417.956 -455.946)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M458.35,495.255a6.648,6.648,0,1,1-6.647-6.649A6.646,6.646,0,0,1,458.35,495.255Z",
    transform: "translate(-417.956 -467.797)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1043",
    "data-name": "Rectangle 1043",
    width: 6.534,
    height: 58.991,
    rx: 1.366,
    transform: "translate(51.131 17.893)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_82",
    "data-name": "Ellipse 82",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 1.783)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_83",
    "data-name": "Ellipse 83",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 16.13)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_84",
    "data-name": "Ellipse 84",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 30.477)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_85",
    "data-name": "Ellipse 85",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 44.824)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_86",
    "data-name": "Ellipse 86",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 59.171)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_87",
    "data-name": "Ellipse 87",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 73.518)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_88",
    "data-name": "Ellipse 88",
    cx: 3.357,
    cy: 3.357,
    rx: 3.357,
    ry: 3.357,
    transform: "translate(86.183 87.865)",
    fill: "#fff",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x2: 16.193,
    y2: 12.42,
    transform: "translate(12.116 10.425)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    y1: 12.81,
    x2: 16.636,
    transform: "translate(11.913 73.047)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    transform: "translate(11.702 51.933)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    y1: 12.837,
    x2: 16.5,
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x2: 16.5,
    y2: 12.837,
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(11.702 31.401)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    y1: 12.837,
    x2: 16.5,
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    x2: 16.5,
    y2: 12.837,
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 3.188,
    height: 3.188,
    transform: "translate(43.312 33.835)",
    fill: "#004796"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1045",
    "data-name": "Rectangle 1045",
    width: 3.188,
    height: 3.188,
    transform: "translate(43.312 40.211)",
    fill: "#004796"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1046",
    "data-name": "Rectangle 1046",
    width: 3.188,
    height: 3.188,
    transform: "translate(43.312 52.964)",
    fill: "#004796"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1047",
    "data-name": "Rectangle 1047",
    width: 3.188,
    height: 3.188,
    transform: "translate(43.312 59.34)",
    fill: "#004796"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M458.215,500.591h15.777l6.5-6.376h6.24",
    transform: "translate(-400.55 -460.38)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M458.215,500.818h9.575l12.8-12.8h6.141",
    transform: "translate(-400.55 -468.578)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M458.215,501.349h4.718l19.54-19.54h4.26",
    transform: "translate(-400.55 -476.786)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M458.215,503.861h15.777l6.5,6.376h6.24",
    transform: "translate(-400.55 -447.622)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M458.215,507.293h9.575l12.8,12.8h6.141",
    transform: "translate(-400.55 -443.084)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M458.215,510.6h4.718l19.54,19.54h4.26",
    transform: "translate(-400.55 -438.712)",
    fill: "none",
    stroke: "#004796",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2476",
    "data-name": "Group 2476",
    transform: "translate(1397.347 10029.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_606",
    "data-name": "Group 606",
    transform: "translate(0 99.219)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_605",
    "data-name": "Group 605",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M146.762,660.768a9.664,9.664,0,0,1,3.728,6.134h-6.3a4.9,4.9,0,0,0-1.918-2.109,5.853,5.853,0,0,0-3.1-.78,5.792,5.792,0,0,0-4.529,1.9,7.407,7.407,0,0,0-1.707,5.14,7.521,7.521,0,0,0,1.793,5.4,6.718,6.718,0,0,0,5.107,1.884,6.033,6.033,0,0,0,5.992-4.5H138.3v-4.28H150.8v5.887a12,12,0,0,1-2.23,4,11.524,11.524,0,0,1-3.918,3,12.423,12.423,0,0,1-5.453,1.152A12.952,12.952,0,0,1,132.687,682a10.836,10.836,0,0,1-4.3-4.441,14.765,14.765,0,0,1,0-13.027,10.878,10.878,0,0,1,4.285-4.443,12.779,12.779,0,0,1,6.461-1.586A12.33,12.33,0,0,1,146.762,660.768Z",
    transform: "translate(-75.032 -658.506)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M150.409,661.75a6.084,6.084,0,0,1,2.369,2.752v-3.519H158.7v19.441h-5.922V676.9a6.093,6.093,0,0,1-2.369,2.755,7.058,7.058,0,0,1-3.832,1.01,7.908,7.908,0,0,1-4.3-1.2,8.214,8.214,0,0,1-3-3.47,13.35,13.35,0,0,1,0-10.607,8.189,8.189,0,0,1,3-3.447,7.851,7.851,0,0,1,4.3-1.2A7.055,7.055,0,0,1,150.409,661.75Zm-5,5.469a5.778,5.778,0,0,0,0,6.967,4.371,4.371,0,0,0,6.168-.035,5.577,5.577,0,0,0,0-6.914,4.4,4.4,0,0,0-6.168-.019Z",
    transform: "translate(-60.077 -655.549)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M162.178,662.588a8.011,8.011,0,0,1,2.771,4.877h-5.576a3.086,3.086,0,0,0-1.094-1.865,3.341,3.341,0,0,0-2.144-.68,2.343,2.343,0,0,0-1.533.434,1.517,1.517,0,0,0-.523,1.24,1.447,1.447,0,0,0,.957,1.356,14.984,14.984,0,0,0,3.015.906,30.753,30.753,0,0,1,3.656,1.061,6.108,6.108,0,0,1,2.476,1.76,4.862,4.862,0,0,1,1.045,3.275,5.015,5.015,0,0,1-.908,2.964,5.932,5.932,0,0,1-2.613,2.018,10.143,10.143,0,0,1-4.039.734,10.4,10.4,0,0,1-6.305-1.742,7.36,7.36,0,0,1-2.891-4.984h5.748a2.585,2.585,0,0,0,1.064,1.918,4.008,4.008,0,0,0,2.385.662,2.221,2.221,0,0,0,1.533-.472,1.586,1.586,0,0,0,.523-1.238,1.487,1.487,0,0,0-.957-1.442,17.83,17.83,0,0,0-3.119-.927,24.353,24.353,0,0,1-3.553-.975,5.866,5.866,0,0,1-2.4-1.686,4.7,4.7,0,0,1-1.01-3.189,5.209,5.209,0,0,1,1.983-4.234,8.67,8.67,0,0,1,5.609-1.619A8.906,8.906,0,0,1,162.178,662.588Z",
    transform: "translate(-46.469 -655.549)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M125.158,693.3a10.832,10.832,0,0,1-4.459,4.373,14.206,14.206,0,0,1-6.847,1.57h-9.3V674.611h9.3a14.481,14.481,0,0,1,6.863,1.533,10.711,10.711,0,0,1,4.443,4.32,14.07,14.07,0,0,1,0,12.836Zm-6.41-1.233a7.934,7.934,0,0,0,0-10.384,7.54,7.54,0,0,0-5.418-1.846H110.51v14.076h2.819A7.54,7.54,0,0,0,118.748,692.067Z",
    transform: "translate(-104.551 -637.208)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M134.409,687.783H120.93a4.5,4.5,0,0,0,1.112,3.152,3.586,3.586,0,0,0,2.578.959,3.5,3.5,0,0,0,2.2-.664,3.068,3.068,0,0,0,1.15-1.7h6.305A8.286,8.286,0,0,1,132.6,693.2a8.96,8.96,0,0,1-3.275,2.545,10.369,10.369,0,0,1-4.424.924,10.5,10.5,0,0,1-5.07-1.2,8.593,8.593,0,0,1-3.465-3.47,10.73,10.73,0,0,1-1.254-5.3,10.853,10.853,0,0,1,1.236-5.311,8.453,8.453,0,0,1,3.465-3.447,11.436,11.436,0,0,1,10.175-.019,8.346,8.346,0,0,1,3.4,3.326,9.9,9.9,0,0,1,1.2,4.931A8.229,8.229,0,0,1,134.409,687.783ZM127.53,682.4a3.772,3.772,0,0,0-2.629-.962,3.9,3.9,0,0,0-2.717.975,4.085,4.085,0,0,0-1.222,2.857h7.6A3.571,3.571,0,0,0,127.53,682.4Z",
    transform: "translate(-90.584 -634.39)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M136.693,693.884v5.121h-2.685a7.7,7.7,0,0,1-5.311-1.693q-1.9-1.686-1.9-5.588V684.58h-2.613v-5.016H126.8v-4.773h5.955v4.773h3.9v5.016h-3.9v7.248a2.167,2.167,0,0,0,.474,1.6,2.229,2.229,0,0,0,1.584.455Z",
    transform: "translate(-78.583 -636.97)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M149.874,687.783H136.392a4.509,4.509,0,0,0,1.115,3.152,3.586,3.586,0,0,0,2.578.959,3.5,3.5,0,0,0,2.2-.664,3.068,3.068,0,0,0,1.15-1.7h6.305a8.286,8.286,0,0,1-1.672,3.674,8.96,8.96,0,0,1-3.275,2.545,10.379,10.379,0,0,1-4.427.924,10.493,10.493,0,0,1-5.068-1.2,8.593,8.593,0,0,1-3.465-3.47,11.919,11.919,0,0,1-.019-10.607,8.439,8.439,0,0,1,3.465-3.447,11.436,11.436,0,0,1,10.175-.019,8.346,8.346,0,0,1,3.4,3.326,9.9,9.9,0,0,1,1.2,4.931A8.211,8.211,0,0,1,149.874,687.783ZM143,682.4a3.774,3.774,0,0,0-2.631-.962,3.9,3.9,0,0,0-2.715.975,4.085,4.085,0,0,0-1.222,2.857h7.6A3.579,3.579,0,0,0,143,682.4Z",
    transform: "translate(-70.133 -634.39)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M155.954,678.816a9.166,9.166,0,0,1,3.205,5.692h-6.306a3.341,3.341,0,0,0-1.15-1.951,3.408,3.408,0,0,0-2.192-.694,3.18,3.18,0,0,0-2.578,1.233,6.93,6.93,0,0,0,0,7.214,3.185,3.185,0,0,0,2.578,1.238,3.4,3.4,0,0,0,2.192-.7,3.32,3.32,0,0,0,1.15-1.948h6.306a9.2,9.2,0,0,1-3.205,5.7,9.668,9.668,0,0,1-6.3,2.072,10.5,10.5,0,0,1-5.07-1.2,8.594,8.594,0,0,1-3.465-3.47,10.73,10.73,0,0,1-1.254-5.3,10.853,10.853,0,0,1,1.236-5.311,8.453,8.453,0,0,1,3.465-3.447,10.531,10.531,0,0,1,5.089-1.2A9.632,9.632,0,0,1,155.954,678.816Z",
    transform: "translate(-57.854 -634.39)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M161.368,693.884v5.121h-2.685a7.7,7.7,0,0,1-5.311-1.693q-1.9-1.686-1.9-5.588V684.58h-2.613v-5.016h2.613v-4.773h5.955v4.773h3.9v5.016h-3.9v7.248a2.177,2.177,0,0,0,.471,1.6,2.24,2.24,0,0,0,1.586.455Z",
    transform: "translate(-45.951 -636.97)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M156.424,674.028a4.185,4.185,0,0,1,5.154,0,2.918,2.918,0,0,1,.975,2.25,2.862,2.862,0,0,1-.975,2.209,4.177,4.177,0,0,1-5.154,0,2.856,2.856,0,0,1-.978-2.209A2.912,2.912,0,0,1,156.424,674.028Zm5.537,7.718v19.441H156V681.746Z",
    transform: "translate(-37.244 -639.152)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M174.863,677.945a8.774,8.774,0,0,1,3.586,3.465,11.371,11.371,0,0,1,0,10.588,8.828,8.828,0,0,1-3.586,3.47,11.779,11.779,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.47,11.371,11.371,0,0,1,0-10.588,8.741,8.741,0,0,1,3.607-3.465,11.759,11.759,0,0,1,10.363,0Zm-8.047,5.188a5.011,5.011,0,0,0-1.168,3.57,4.945,4.945,0,0,0,1.168,3.553,3.811,3.811,0,0,0,2.873,1.219,3.758,3.758,0,0,0,2.857-1.219A4.983,4.983,0,0,0,173.7,686.7a5.049,5.049,0,0,0-1.152-3.57,3.742,3.742,0,0,0-2.857-1.238A3.794,3.794,0,0,0,166.816,683.133Z",
    transform: "translate(-31.769 -634.39)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M187.252,678.988a8.937,8.937,0,0,1,1.967,6.127v11.292h-5.957V685.814a4.279,4.279,0,0,0-1.029-3.047,3.567,3.567,0,0,0-2.734-1.1,3.73,3.73,0,0,0-2.875,1.152,4.652,4.652,0,0,0-1.061,3.27v10.316h-5.957V676.965h5.957v3.556a6.448,6.448,0,0,1,2.492-2.755,7.317,7.317,0,0,1,3.883-1.01A6.729,6.729,0,0,1,187.252,678.988Z",
    transform: "translate(-18.518 -634.371)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_607",
    "data-name": "Group 607",
    transform: "translate(34.069 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1048",
    "data-name": "Rectangle 1048",
    width: 15.052,
    height: 5.757,
    rx: 1.044,
    transform: "translate(43.847 21.879)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M174.042,635.9H126.483a7.929,7.929,0,0,1,7.94-7.94,7.225,7.225,0,0,1,1.694.185v-.027a8.337,8.337,0,0,1,16.673,0,1.508,1.508,0,0,1-.027.344,8.964,8.964,0,0,1,2.408-.344A8.281,8.281,0,0,1,160.465,630a8.209,8.209,0,0,1,5.267-1.879A8.335,8.335,0,0,1,174.042,635.9Z",
    transform: "translate(-114.23 -619.785)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1049",
    "data-name": "Rectangle 1049",
    width: 102.74,
    height: 17.282,
    rx: 1.05,
    transform: "translate(0 16.117)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M145.092,645.805l5.915-11.033",
    transform: "translate(-83.589 -595.108)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M148.976,641.02l4.4-6.19",
    transform: "translate(-77.194 -595.012)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M179.779,653.862a7.39,7.39,0,0,1-6.3,7.331,7.4,7.4,0,0,1-14.53.08h-9.872a7.4,7.4,0,0,1-7.146-7.41,7.057,7.057,0,0,1,1.217-4.023,7.266,7.266,0,0,1,7.887-3.176,7.473,7.473,0,0,1-.318-2.2,7.4,7.4,0,0,1,13.921-3.52c.291-.027.609-.053.9-.053a7.615,7.615,0,0,1,2.355.371,7.472,7.472,0,0,1,4.817,5.187A7.419,7.419,0,0,1,179.779,653.862Z",
    transform: "translate(-88.79 -591.35)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M205.317,632.4,193.566,648.92a7.618,7.618,0,0,0-2.355-.371c-.291,0-.609.026-.9.053a7.4,7.4,0,0,0-13.921,3.52,7.473,7.473,0,0,0,.318,2.2,7.266,7.266,0,0,0-7.887,3.176H144.207l-9.422-13.233L126.343,632.4Z",
    transform: "translate(-114.46 -599.005)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M155.388,650.118a8.287,8.287,0,0,1-15.3,4.417,9.407,9.407,0,1,1-6.458-17.65l9.422,13.233Z",
    transform: "translate(-113.308 -591.629)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M140.186,645.615l-7.937-11.092",
    transform: "translate(-104.736 -595.518)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M141.737,645.864l-1.763-11.092",
    transform: "translate(-92.016 -595.108)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M143.056,646.588l1.76-11.96",
    transform: "translate(-86.941 -595.345)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M141.08,645.72,136.2,634.628",
    transform: "translate(-98.235 -595.345)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2478",
    "data-name": "Group 2478",
    transform: "translate(1091.814 10726.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569",
    transform: "translate(0 102.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M285.484,678.826h7.943v4.563h-13.9V658.76h5.959Z",
    transform: "translate(-279.525 -655.348)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M287.433,658.181a4.181,4.181,0,0,1,5.156,0,3.036,3.036,0,0,1,0,4.459,4.181,4.181,0,0,1-5.156,0,3.031,3.031,0,0,1,0-4.459Zm5.539,7.715v19.437h-5.959V665.9Z",
    transform: "translate(-270.36 -657.291)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M302.821,661.9a6.1,6.1,0,0,1,2.371,2.75v-3.516h5.922v19.332a11.16,11.16,0,0,1-1.047,4.9,7.981,7.981,0,0,1-3.2,3.465,10.3,10.3,0,0,1-5.367,1.294,11.034,11.034,0,0,1-7.019-2.074,8.438,8.438,0,0,1-3.154-5.63h5.888a2.947,2.947,0,0,0,1.273,1.846,4.578,4.578,0,0,0,2.594.662,4.175,4.175,0,0,0,2.98-1.061,4.474,4.474,0,0,0,1.133-3.4v-3.409a6.069,6.069,0,0,1-2.371,2.747,7.011,7.011,0,0,1-3.83,1.013,7.853,7.853,0,0,1-4.3-1.2,8.218,8.218,0,0,1-3-3.465,13.382,13.382,0,0,1,0-10.609,8.24,8.24,0,0,1,3-3.449,7.87,7.87,0,0,1,4.3-1.2A7.009,7.009,0,0,1,302.821,661.9Zm-5,5.472a5.778,5.778,0,0,0,0,6.967,4.376,4.376,0,0,0,6.166-.037,5.572,5.572,0,0,0,0-6.916,4.065,4.065,0,0,0-3.084-1.27A4,4,0,0,0,297.823,667.373Z",
    transform: "translate(-264.884 -652.53)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M318.846,666.624a8.969,8.969,0,0,1,1.967,6.134v11.285h-5.957V673.457a4.284,4.284,0,0,0-1.027-3.049,3.565,3.565,0,0,0-2.736-1.1,3.72,3.72,0,0,0-2.873,1.15,4.65,4.65,0,0,0-1.061,3.275v10.309H301.2V658.266h5.959v9.891a6.422,6.422,0,0,1,2.49-2.752,7.319,7.319,0,0,1,3.885-1.008A6.743,6.743,0,0,1,318.846,666.624Z",
    transform: "translate(-250.861 -656.002)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M323.2,678.029v5.121h-2.682a7.726,7.726,0,0,1-5.311-1.686c-1.266-1.131-1.9-2.989-1.9-5.595V668.73h-2.613v-5.017h2.613v-4.773h5.957v4.773h3.9v5.017h-3.9v7.244a2.17,2.17,0,0,0,.471,1.6,2.234,2.234,0,0,0,1.584.453Z",
    transform: "translate(-238.304 -655.109)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_611",
    "data-name": "Group 611",
    transform: "translate(10.502)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_610",
    "data-name": "Group 610"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_609",
    "data-name": "Group 609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M308.927,620.062a20.274,20.274,0,0,0-13.4,35.462c3.2,3.2,2.912,10.047,2.838,10.121a1.208,1.208,0,0,0,.365.945,1.345,1.345,0,0,0,.873.365h18.568a1.2,1.2,0,0,0,.873-.365,1.385,1.385,0,0,0,.365-.945c0-.074-.365-6.919,2.84-10.121l.218-.221a20.211,20.211,0,0,0-13.545-35.241Z",
    transform: "translate(-277.911 -604.334)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M298.076,622.288a1.238,1.238,0,1,0,0,2.476,13.253,13.253,0,0,1,13.252,13.252,1.238,1.238,0,0,0,2.476,0A15.661,15.661,0,0,0,298.076,622.288Z",
    transform: "translate(-267.131 -601.39)",
    fill: "#e1e1e2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M297.9,621.737V613.29",
    transform: "translate(-265.722 -613.29)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M304.363,623.165l4.659-6.991",
    transform: "translate(-257.18 -609.476)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M294.017,622.485l-4.515-7.063",
    transform: "translate(-276.833 -610.47)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M291.4,624.913l-7.353-4",
    transform: "translate(-284.047 -603.214)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M308.031,625.855l7.427-4.006",
    transform: "translate(-252.329 -601.971)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1050",
    "data-name": "Rectangle 1050",
    width: 21.269,
    height: 5.052,
    rx: 1.044,
    transform: "translate(20.311 66.367)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1051",
    "data-name": "Rectangle 1051",
    width: 21.269,
    height: 5.052,
    rx: 1.044,
    transform: "translate(20.311 73.956)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_616",
    "data-name": "Group 616",
    transform: "translate(1368.523 10716.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_613",
    "data-name": "Group 613",
    transform: "translate(0 123.815)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_612",
    "data-name": "Group 612"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M423.843,660.98a11.307,11.307,0,0,1,3.99,6.689h-6.306a5.787,5.787,0,0,0-2.144-2.682,5.988,5.988,0,0,0-3.433-.975,5.222,5.222,0,0,0-4.213,1.916,7.725,7.725,0,0,0-1.6,5.121,7.648,7.648,0,0,0,1.6,5.1,5.244,5.244,0,0,0,4.213,1.9,5.988,5.988,0,0,0,3.433-.975,5.808,5.808,0,0,0,2.144-2.65h6.306a11.365,11.365,0,0,1-3.99,6.672,11.989,11.989,0,0,1-7.785,2.492A12.3,12.3,0,0,1,409.75,682a10.783,10.783,0,0,1-4.2-4.441,15.083,15.083,0,0,1,0-13.029,10.8,10.8,0,0,1,4.2-4.443,12.3,12.3,0,0,1,6.308-1.584A12.044,12.044,0,0,1,423.843,660.98Z",
    transform: "translate(-404.074 -655.337)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M430.584,661.945a8.793,8.793,0,0,1,3.588,3.465,11.388,11.388,0,0,1,0,10.588,8.82,8.82,0,0,1-3.588,3.47,11.779,11.779,0,0,1-10.363,0,8.8,8.8,0,0,1-3.607-3.47,11.389,11.389,0,0,1,0-10.588,8.769,8.769,0,0,1,3.607-3.465,11.76,11.76,0,0,1,10.363,0Zm-8.047,5.188a5.017,5.017,0,0,0-1.168,3.572,4.936,4.936,0,0,0,1.168,3.551,3.813,3.813,0,0,0,2.873,1.221,3.766,3.766,0,0,0,2.859-1.221,4.983,4.983,0,0,0,1.15-3.551,5.065,5.065,0,0,0-1.15-3.572,3.754,3.754,0,0,0-2.859-1.236A3.8,3.8,0,0,0,422.536,667.133Z",
    transform: "translate(-389.216 -652.381)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M442.974,662.987a8.948,8.948,0,0,1,1.967,6.129V680.4h-5.957v-10.59a4.289,4.289,0,0,0-1.027-3.047,3.565,3.565,0,0,0-2.736-1.1,3.72,3.72,0,0,0-2.873,1.15,4.648,4.648,0,0,0-1.064,3.272V680.4h-5.957V660.966h5.957v3.553a6.448,6.448,0,0,1,2.492-2.754,7.318,7.318,0,0,1,3.885-1.008A6.73,6.73,0,0,1,442.974,662.987Z",
    transform: "translate(-375.966 -652.361)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M453.112,662.987a8.937,8.937,0,0,1,1.969,6.129V680.4h-5.957v-10.59a4.279,4.279,0,0,0-1.029-3.047,3.561,3.561,0,0,0-2.736-1.1,3.727,3.727,0,0,0-2.873,1.15,4.647,4.647,0,0,0-1.061,3.272V680.4h-5.957V660.966h5.957v3.553a6.442,6.442,0,0,1,2.49-2.754,7.33,7.33,0,0,1,3.885-1.008A6.726,6.726,0,0,1,453.112,662.987Z",
    transform: "translate(-362.557 -652.361)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M464.47,671.785h-13.48a4.5,4.5,0,0,0,1.112,3.152,3.588,3.588,0,0,0,2.58.959,3.515,3.515,0,0,0,2.195-.664,3.077,3.077,0,0,0,1.15-1.7h6.306a8.286,8.286,0,0,1-1.672,3.674,8.932,8.932,0,0,1-3.275,2.543,11.185,11.185,0,0,1-9.494-.276,8.58,8.58,0,0,1-3.465-3.47,10.72,10.72,0,0,1-1.254-5.293,10.861,10.861,0,0,1,1.236-5.314,8.48,8.48,0,0,1,3.465-3.447,11.437,11.437,0,0,1,10.175-.018,8.351,8.351,0,0,1,3.4,3.328,9.893,9.893,0,0,1,1.2,4.928A8.231,8.231,0,0,1,464.47,671.785Zm-6.879-5.381a3.77,3.77,0,0,0-2.629-.959,3.906,3.906,0,0,0-2.717.973,4.086,4.086,0,0,0-1.222,2.859h7.6A3.576,3.576,0,0,0,457.591,666.4Z",
    transform: "translate(-349.722 -652.381)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M470.553,662.816a9.193,9.193,0,0,1,3.205,5.694h-6.306a3.327,3.327,0,0,0-1.15-1.951,3.4,3.4,0,0,0-2.195-.7,3.182,3.182,0,0,0-2.578,1.236,6.926,6.926,0,0,0,0,7.211,3.185,3.185,0,0,0,2.578,1.238,3.39,3.39,0,0,0,2.195-.7,3.313,3.313,0,0,0,1.15-1.949h6.306a9.211,9.211,0,0,1-3.205,5.7,9.667,9.667,0,0,1-6.306,2.072,10.47,10.47,0,0,1-5.07-1.2,8.581,8.581,0,0,1-3.465-3.47,10.747,10.747,0,0,1-1.254-5.293,10.862,10.862,0,0,1,1.236-5.314,8.48,8.48,0,0,1,3.465-3.447,10.532,10.532,0,0,1,5.088-1.2A9.643,9.643,0,0,1,470.553,662.816Z",
    transform: "translate(-337.443 -652.381)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M475.964,677.883V683H473.28a7.709,7.709,0,0,1-5.312-1.691q-1.9-1.689-1.9-5.59v-7.141h-2.613v-5.017h2.613v-4.773h5.955v4.773h3.9v5.017h-3.9v7.246a2.167,2.167,0,0,0,.474,1.6,2.23,2.23,0,0,0,1.584.455Z",
    transform: "translate(-325.541 -654.96)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M471.02,658.029a4.19,4.19,0,0,1,5.156,0,2.916,2.916,0,0,1,.973,2.248,2.873,2.873,0,0,1-.973,2.211,4.18,4.18,0,0,1-5.156,0,2.869,2.869,0,0,1-.978-2.211A2.912,2.912,0,0,1,471.02,658.029Zm5.539,7.717v19.439H470.6V665.747Z",
    transform: "translate(-316.834 -657.142)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M484.537,674.468l4.218-13.621h6.338l-6.9,19.439h-7.383l-6.9-19.439h6.343Z",
    transform: "translate(-311.716 -652.242)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M484.834,658.029a4.19,4.19,0,0,1,5.156,0,2.918,2.918,0,0,1,.975,2.248,2.875,2.875,0,0,1-.975,2.211,4.18,4.18,0,0,1-5.156,0,2.869,2.869,0,0,1-.978-2.211A2.912,2.912,0,0,1,484.834,658.029Zm5.539,7.717v19.439h-5.957V665.747Z",
    transform: "translate(-298.566 -657.142)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M500.293,677.883V683h-2.682a7.711,7.711,0,0,1-5.314-1.691q-1.9-1.689-1.9-5.59v-7.141h-2.613v-5.017H490.4v-4.773h5.955v4.773h3.9v5.017h-3.9v7.246a2.167,2.167,0,0,0,.474,1.6,2.229,2.229,0,0,0,1.584.455Z",
    transform: "translate(-293.367 -654.96)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M500.336,660.847,505,672.761l4.355-11.914h6.584L503.82,689.553h-6.552l4.564-10-8.15-18.705Z",
    transform: "translate(-285.571 -652.242)",
    fill: "#004797"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_615",
    "data-name": "Group 615",
    transform: "translate(62.267)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M472.577,609.122H436.184a3.312,3.312,0,0,0-3.31,3.31v62.86a3.313,3.313,0,0,0,3.31,3.31h36.393a3.313,3.313,0,0,0,3.31-3.31v-62.86A3.312,3.312,0,0,0,472.577,609.122Z",
    transform: "translate(-428.253 -596.832)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M441.385,605.58h10.451v3.484H441.385Z",
    transform: "translate(-416.999 -601.516)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M438.385,605.58h3.484v3.484h-3.484Z",
    transform: "translate(-420.967 -601.516)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M440.919,648.008v-5.643h5.646l0,5.643Z",
    transform: "translate(-417.615 -552.869)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_614",
    "data-name": "Group 614",
    transform: "translate(7.364 89.719)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M435.58,647.661h-1.524v-5.2h1.524l2.6,2.6Z",
    transform: "translate(-434.056 -642.461)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M451.013,647.542l-2.524-2.524,2.524-2.525H452.5l0,5.049Z",
    transform: "translate(-414.969 -642.419)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M486.475,701.1a29.614,29.614,0,1,0,.149-44.863m-8.709,48.621h-41.8a5.232,5.232,0,0,1-5.226-5.225V609.055a5.233,5.233,0,0,1,5.226-5.225h41.8a5.232,5.232,0,0,1,5.225,5.225v90.576A5.23,5.23,0,0,1,477.915,704.857Z",
    transform: "translate(-430.885 -603.83)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M468.632,621.124a3.5,3.5,0,1,1-3.5-3.5A3.5,3.5,0,0,1,468.632,621.124Z",
    transform: "translate(-390.23 -585.591)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M461.453,619.217l-2.508-2.641a14.84,14.84,0,0,1,19.464,0l-2.508,2.641a11.683,11.683,0,0,0-14.448,0Z",
    transform: "translate(-393.777 -591.782)",
    fill: "#004797"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M435.987,630.83h0Z",
    transform: "translate(-424.138 -568.124)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M435.987,633.08h0Z",
    transform: "translate(-424.138 -565.148)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M435.987,626.484h0Z",
    transform: "translate(-424.138 -573.871)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M435.987,628.734h0Z",
    transform: "translate(-424.138 -570.895)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M435.987,635.159h29.035v.142H435.987Z",
    transform: "translate(-424.138 -562.399)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M445.088,633.755h16.685v-13.9H453.43v-5.562H436.748v13.9h8.34Z",
    transform: "translate(-423.131 -589.996)",
    fill: "#e1e1e2",
    stroke: "#004797",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M468.268,651.71c-3.533,0-6.733-3.778-8.777-9.5h17.555c-2.044,5.718-5.244,9.5-8.779,9.5Z",
    transform: "translate(-393.055 -553.069)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M459.808,646.259a44.786,44.786,0,0,1-1.291-9.5H480.6a44.928,44.928,0,0,1-1.291,9.5Z",
    transform: "translate(-394.343 -560.279)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M468.268,625.857c3.535,0,6.735,3.779,8.779,9.5H459.491c2.044-5.718,5.244-9.5,8.777-9.5Z",
    transform: "translate(-393.055 -574.7)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M479.307,631.309a44.931,44.931,0,0,1,1.291,9.5H458.516a44.939,44.939,0,0,1,1.291-9.5Z",
    transform: "translate(-394.344 -567.49)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M458.98,640.808h-3.207v-9.5h4.4A48.182,48.182,0,0,0,458.98,640.808Z",
    transform: "translate(-397.972 -567.49)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M455.773,636.762h3.207a48.182,48.182,0,0,0,1.191,9.5h-4.4Z",
    transform: "translate(-397.972 -560.279)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M470.065,636.762h9.457a23.574,23.574,0,0,1-2.68,9.5h-7.968a48.175,48.175,0,0,0,1.191-9.5Z",
    transform: "translate(-380.646 -560.279)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M470.065,640.808a48.175,48.175,0,0,0-1.191-9.5h7.968a23.574,23.574,0,0,1,2.68,9.5Z",
    transform: "translate(-380.646 -567.49)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M477.626,634.532h-6.819a26.389,26.389,0,0,0-4.062-8.054A23.828,23.828,0,0,1,477.626,634.532Z",
    transform: "translate(-383.461 -573.879)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M465.107,626.484a26.376,26.376,0,0,0-4.053,8.04h-5.281V632.7A23.772,23.772,0,0,1,465.107,626.484Z",
    transform: "translate(-397.972 -573.871)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M455.773,644.037v-1.823h5.281a26.324,26.324,0,0,0,4.053,8.04A23.773,23.773,0,0,1,455.773,644.037Z",
    transform: "translate(-397.972 -553.069)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M466.745,650.268a26.388,26.388,0,0,0,4.062-8.055h6.819A23.829,23.829,0,0,1,466.745,650.268Z",
    transform: "translate(-383.461 -553.069)",
    fill: "none",
    stroke: "#004797",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M473.65,608.756a26.86,26.86,0,0,1,18.459,7.362l-2.248,2.355a23.955,23.955,0,0,0-32.426,0l-2.248-2.355A26.883,26.883,0,0,1,473.65,608.756Z",
    transform: "translate(-398.748 -597.316)",
    fill: "#004797"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenstra06);
export default __webpack_public_path__ + "static/media/senstra_06.5170dc2e580ba67ed8fde9f86c8d1264.svg";
export { ForwardRef as ReactComponent };